/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AclPermissionsRow = {
  __typename: 'AclPermissionsRow';
  c: Scalars['Boolean'];
  d: Scalars['Boolean'];
  entity: Scalars['String'];
  r: Scalars['Boolean'];
  u: Scalars['Boolean'];
};

/** ACL Roles */
export type AclRole = ApiNode & OwnedApiNode & {
  __typename: 'AclRole';
  _id: Scalars['Float'];
  /** A JSON Object where the keys are the entity/procedure and the value is an object with action name as key and true/false as value */
  acl: Scalars['String'];
  active: Scalars['Boolean'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  id: Scalars['ID'];
  name: Scalars['String'];
  shareWithChildBranches: Scalars['Boolean'];
  updatedAt: Scalars['Timestamp'];
  user: Profile;
};

export type AclRoleInput = {
  /** JSON String with ACL data */
  acl: Scalars['String'];
  active: Scalars['Boolean'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type ApiNode = {
  _id: Scalars['Float'];
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  updatedAt: Scalars['Timestamp'];
};

/** Event attendee type */
export enum AttendeeType {
  Attendee = 'Attendee',
  Invited = 'Invited',
  Unsubscribed = 'Unsubscribed'
}

export type Calendar = ApiNode & OwnedApiNode & {
  __typename: 'Calendar';
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  color: Scalars['String'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  events: Array<CalendarEvent>;
  frontInactive?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  shareWithChildBranches: Scalars['Boolean'];
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type CalendarEvent = ApiNode & EventData & OwnedApiNode & {
  __typename: 'CalendarEvent';
  _id: Scalars['Float'];
  accessType: EventAccessType;
  allDay: Scalars['Boolean'];
  allRecurrenceEvents: Array<CalendarEvent>;
  attendeeLimit: Scalars['Float'];
  attendees: Array<EventAttendee>;
  branch?: Maybe<OrganizationBranch>;
  calendar: Calendar;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  city?: Maybe<City>;
  color: Scalars['String'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  description?: Maybe<Scalars['String']>;
  end: Scalars['Int'];
  eventImport?: Maybe<EventImport>;
  featuredImage?: Maybe<Media>;
  files: Array<NodeMedia>;
  hasAttendeeRegistration: Scalars['Boolean'];
  id: Scalars['ID'];
  id_calendar: Scalars['ID'];
  id_type?: Maybe<Scalars['ID']>;
  isFinished: Scalars['Boolean'];
  isOnline: Scalars['Boolean'];
  isPathwayEvent: Scalars['Boolean'];
  language: Array<Scalars['String']>;
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  notificationTemplates: Array<EventNotificationTemplate>;
  organizers: Array<Organizer>;
  pathway?: Maybe<Pathway>;
  pathwayDescendants: Array<CalendarEvent>;
  pathwayItem?: Maybe<PathwayItem>;
  postalCode?: Maybe<Scalars['String']>;
  recurrence?: Maybe<Recurrence>;
  recurrenceDate?: Maybe<Scalars['Int']>;
  reminders?: Maybe<Array<ReminderItem>>;
  rootEvent: Scalars['Boolean'];
  shareWithChildBranches: Scalars['Boolean'];
  start: Scalars['Int'];
  tags: Array<EventTag>;
  title: Scalars['String'];
  type?: Maybe<EventType>;
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type CalendarInput = {
  color: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type City = ApiNode & {
  __typename: 'City';
  _id: Scalars['Float'];
  administrativeArea?: Maybe<Scalars['String']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']>;
  administrativeAreaLevel3?: Maybe<Scalars['String']>;
  administrativeAreaLevel4?: Maybe<Scalars['String']>;
  administrativeAreaLevel5?: Maybe<Scalars['String']>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['Timestamp'];
  events?: Maybe<CalendarEvent>;
  id: Scalars['ID'];
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Timestamp'];
};

export type CitySearchQueryInput = {
  country?: InputMaybe<Scalars['String']>;
};

export type Constants = {
  __typename: 'Constants';
  aclRolesEntities: Array<KeyValue>;
  /** All notification types, including those hidden from calendar settings */
  allNotificationTypes: Array<KeyValue>;
  locales: Array<Locale>;
  notificationMethods: Array<KeyValue>;
  notificationTypes: Array<KeyValue>;
};

export type CoordsSearch = {
  /** Distance from cords in meters */
  distance?: Scalars['Float'];
  fromCoords: LatLngInput;
};

export type CustomDomainNameDnsRecords = ApiNode & OwnedApiNode & {
  __typename: 'CustomDomainNameDnsRecords';
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  customDomainNameRequest: CustomDomainNameRequest;
  id: Scalars['ID'];
  name: Scalars['String'];
  shareWithChildBranches: Scalars['Boolean'];
  type: DnsRecordType;
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
  validated: Scalars['Boolean'];
  value: Scalars['String'];
};

export type CustomDomainNameRequest = ApiNode & OwnedApiNode & {
  __typename: 'CustomDomainNameRequest';
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  customDomainNameDnsRecords: Array<CustomDomainNameDnsRecords>;
  domainName: Scalars['String'];
  fromEmail: Scalars['String'];
  fromEmailName: Scalars['String'];
  id: Scalars['ID'];
  shareWithChildBranches: Scalars['Boolean'];
  status: CustomDomainRequestStatus;
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type CustomDomainNameRequestInput = {
  domainName: Scalars['String'];
  fromEmail: Scalars['String'];
  fromEmailName: Scalars['String'];
};

/** Custom domain request status */
export enum CustomDomainRequestStatus {
  cancelled = 'cancelled',
  configured = 'configured',
  done = 'done',
  inProgress = 'inProgress',
  requested = 'requested'
}

/** Dns record type */
export enum DnsRecordType {
  cname = 'cname',
  mx = 'mx',
  txt = 'txt'
}

export type EmailValidationResponse = {
  __typename: 'EmailValidationResponse';
  email: Scalars['String'];
  setPasswordToken?: Maybe<Scalars['String']>;
};

/** Event access type */
export enum EventAccessType {
  Invitation = 'Invitation',
  Private = 'Private',
  Public = 'Public'
}

export type EventAttendee = ApiNode & {
  __typename: 'EventAttendee';
  _id: Scalars['Float'];
  attended: Scalars['Boolean'];
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  confirmed: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  event: CalendarEvent;
  id: Scalars['ID'];
  localeFromSelector?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  profile: Profile;
  type: AttendeeType;
  updatedAt: Scalars['Timestamp'];
};

export type EventAttendeeAttendanceInput = {
  attended: Scalars['Boolean'];
  id: Scalars['String'];
};

export type EventAttendeeInput = {
  attended?: InputMaybe<Scalars['Boolean']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  /** Email to be invited, only for invitation types */
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  /** Invitation acceptance reminder configuration */
  invitationReminders?: InputMaybe<Array<ReminderItemInput>>;
  language?: InputMaybe<Scalars['String']>;
  localeFromSelector?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Profile to be invited, only for invitation types */
  profileId?: InputMaybe<Scalars['String']>;
  type?: AttendeeType;
};

export type EventCategory = ApiNode & OwnedApiNode & {
  __typename: 'EventCategory';
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shareWithChildBranches: Scalars['Boolean'];
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type EventCategoryInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type EventData = {
  _id: Scalars['Float'];
  accessType: EventAccessType;
  allDay: Scalars['Boolean'];
  attendeeLimit: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  city?: Maybe<City>;
  color: Scalars['String'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  description?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Media>;
  files: Array<NodeMedia>;
  hasAttendeeRegistration: Scalars['Boolean'];
  id: Scalars['ID'];
  isOnline: Scalars['Boolean'];
  language: Array<Scalars['String']>;
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  organizers: Array<Organizer>;
  postalCode?: Maybe<Scalars['String']>;
  recurrence?: Maybe<Recurrence>;
  reminders?: Maybe<Array<ReminderItem>>;
  shareWithChildBranches: Scalars['Boolean'];
  title: Scalars['String'];
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type EventDataInput = {
  accessType?: EventAccessType;
  allDay?: InputMaybe<Scalars['Boolean']>;
  attendeeLimit?: Scalars['Float'];
  color: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  featuredImageId?: InputMaybe<Scalars['ID']>;
  files?: InputMaybe<Array<NodeMediaInput>>;
  hasAttendeeRegistration?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isOnline?: InputMaybe<Scalars['Boolean']>;
  language?: Array<Scalars['String']>;
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  locationName?: InputMaybe<Scalars['String']>;
  notificationTemplates?: InputMaybe<Array<Scalars['ID']>>;
  organizersIds?: InputMaybe<Array<Scalars['ID']>>;
  placeId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  recurrence?: InputMaybe<RecurrenceInput>;
  recurrenceType?: RecurrenceType;
  reminders?: InputMaybe<Array<ReminderItemInput>>;
  rrule?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<NodeTagInput>>;
  title: Scalars['String'];
};

export type EventImport = ApiNode & OwnedApiNode & {
  __typename: 'EventImport';
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  dateFormat?: Maybe<Scalars['String']>;
  events: Array<CalendarEvent>;
  file: Media;
  geolocateLocation?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  log?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  shareWithChildBranches: Scalars['Boolean'];
  state: EventImportState;
  tzname?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type EventImportInput = {
  dateFormat?: InputMaybe<Scalars['String']>;
  geolocateLocation?: Scalars['Boolean'];
  id?: InputMaybe<Scalars['ID']>;
  id_media: Scalars['ID'];
  name: Scalars['String'];
  tzname?: InputMaybe<Scalars['String']>;
};

/** Event import state */
export enum EventImportState {
  draft = 'draft',
  failed = 'failed',
  importing = 'importing',
  notValid = 'notValid',
  success = 'success',
  validated = 'validated'
}

export type EventInput = {
  accessType?: EventAccessType;
  allDay?: InputMaybe<Scalars['Boolean']>;
  attendeeLimit?: Scalars['Float'];
  color: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  end: Scalars['Float'];
  featuredImageId?: InputMaybe<Scalars['ID']>;
  files?: InputMaybe<Array<NodeMediaInput>>;
  hasAttendeeRegistration?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  id_calendar: Scalars['ID'];
  id_type?: InputMaybe<Scalars['ID']>;
  isFinished?: InputMaybe<Scalars['Boolean']>;
  isOnline?: InputMaybe<Scalars['Boolean']>;
  language?: Array<Scalars['String']>;
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  locationName?: InputMaybe<Scalars['String']>;
  notificationTemplates?: InputMaybe<Array<Scalars['ID']>>;
  organizersIds?: InputMaybe<Array<Scalars['ID']>>;
  placeId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  recurrence?: InputMaybe<RecurrenceInput>;
  recurrenceType?: RecurrenceType;
  recurrenceUpdateMode?: InputMaybe<RecurrenceUpdateMode>;
  recurrence_id?: InputMaybe<Scalars['Float']>;
  reminders?: InputMaybe<Array<ReminderItemInput>>;
  rrule?: InputMaybe<Scalars['String']>;
  start: Scalars['Float'];
  tags?: InputMaybe<Array<NodeTagInput>>;
  title: Scalars['String'];
};

export type EventNotificationTemplate = ApiNode & OwnedApiNode & RelatedNotificationTemplate & {
  __typename: 'EventNotificationTemplate';
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  id: Scalars['ID'];
  method: NotificationMethod;
  node: CalendarEvent;
  notification: NotificationTemplate;
  shareWithChildBranches: Scalars['Boolean'];
  type: NotificationType;
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type EventSearchQuery = {
  cityId?: InputMaybe<Scalars['ID']>;
  coords?: InputMaybe<CoordsSearch>;
  country?: InputMaybe<Scalars['String']>;
  /** Search start date */
  fromDate: Scalars['Int'];
  location?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<KeyValueInput>>;
  /** Search end date */
  toDate: Scalars['Int'];
};

export type EventSearchResponse = {
  __typename: 'EventSearchResponse';
  hasMore: Scalars['Boolean'];
  items: Array<CalendarEvent>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  total: Scalars['Int'];
};

export type EventTag = ApiNode & NodeTag & {
  __typename: 'EventTag';
  _id: Scalars['Float'];
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  key: Scalars['String'];
  node: CalendarEvent;
  updatedAt: Scalars['Timestamp'];
  value: Scalars['String'];
};

export type EventType = ApiNode & EventData & OwnedApiNode & {
  __typename: 'EventType';
  _id: Scalars['Float'];
  accessType: EventAccessType;
  allDay: Scalars['Boolean'];
  attendeeLimit: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  city?: Maybe<City>;
  code?: Maybe<Scalars['String']>;
  color: Scalars['String'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  description?: Maybe<Scalars['String']>;
  duration: Scalars['Float'];
  events: Array<CalendarEvent>;
  featuredImage?: Maybe<Media>;
  files: Array<NodeMedia>;
  hasAttendeeRegistration: Scalars['Boolean'];
  id: Scalars['ID'];
  isOnline: Scalars['Boolean'];
  language: Array<Scalars['String']>;
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationTemplates: Array<EventTypeNotificationTemplate>;
  organizers: Array<Organizer>;
  postalCode?: Maybe<Scalars['String']>;
  recurrence?: Maybe<Recurrence>;
  reminders?: Maybe<Array<ReminderItem>>;
  shareWithChildBranches: Scalars['Boolean'];
  tags: Array<EventTypeTag>;
  title: Scalars['String'];
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type EventTypeInput = {
  accessType?: EventAccessType;
  allDay?: InputMaybe<Scalars['Boolean']>;
  attendeeLimit?: Scalars['Float'];
  code?: InputMaybe<Scalars['String']>;
  color: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  duration?: Scalars['Float'];
  featuredImageId?: InputMaybe<Scalars['ID']>;
  files?: InputMaybe<Array<NodeMediaInput>>;
  hasAttendeeRegistration?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isOnline?: InputMaybe<Scalars['Boolean']>;
  language?: Array<Scalars['String']>;
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  locationName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notificationTemplates?: InputMaybe<Array<Scalars['ID']>>;
  organizersIds?: InputMaybe<Array<Scalars['ID']>>;
  placeId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  recurrence?: InputMaybe<RecurrenceInput>;
  recurrenceType?: RecurrenceType;
  reminders?: InputMaybe<Array<ReminderItemInput>>;
  rrule?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<NodeTagInput>>;
  title: Scalars['String'];
};

export type EventTypeNotificationTemplate = ApiNode & OwnedApiNode & RelatedNotificationTemplate & {
  __typename: 'EventTypeNotificationTemplate';
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  id: Scalars['ID'];
  method: NotificationMethod;
  node: EventType;
  notification: NotificationTemplate;
  shareWithChildBranches: Scalars['Boolean'];
  type: NotificationType;
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type EventTypeTag = ApiNode & NodeTag & {
  __typename: 'EventTypeTag';
  _id: Scalars['Float'];
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  key: Scalars['String'];
  node: EventType;
  updatedAt: Scalars['Timestamp'];
  value: Scalars['String'];
};

export type InvitePatient = {
  __typename: 'InvitePatient';
  response: Scalars['String'];
};

export type KeyValue = {
  __typename: 'KeyValue';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type KeyValueInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type LatLng = {
  __typename: 'LatLng';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type LatLngInput = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type LocalState = {
  __typename: 'LocalState';
  selectedCalendars?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

/** Available locales */
export enum Locale {
  da_DK = 'da_DK',
  de_AT = 'de_AT',
  de_CH = 'de_CH',
  de_DE = 'de_DE',
  el_GR = 'el_GR',
  en_GB = 'en_GB',
  en_US = 'en_US',
  en_ZA = 'en_ZA',
  es_ES = 'es_ES',
  fi_FI = 'fi_FI',
  fr_CH = 'fr_CH',
  fr_FR = 'fr_FR',
  he_IL = 'he_IL',
  it_CH = 'it_CH',
  it_IT = 'it_IT',
  nb_NO = 'nb_NO',
  nl_NL = 'nl_NL',
  nn_NO = 'nn_NO',
  pt_PT = 'pt_PT',
  sv_SE = 'sv_SE',
  zu_ZA = 'zu_ZA'
}

export type LoginError = {
  __typename: 'LoginError';
  error: Scalars['String'];
  errorDescription: Scalars['String'];
};

export type LoginInput = {
  clientId: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type LoginResponse = LoginError | LoginToken;

export type LoginToken = {
  __typename: 'LoginToken';
  accessToken: Scalars['String'];
  expiresIn: Scalars['Float'];
  refreshToken: Scalars['String'];
  scope: Scalars['String'];
  tokenType: Scalars['String'];
};

export type Media = ApiNode & OwnedApiNode & {
  __typename: 'Media';
  _id: Scalars['Float'];
  altText?: Maybe<Scalars['String']>;
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  description?: Maybe<Scalars['String']>;
  encoding: Scalars['String'];
  filename: Scalars['String'];
  global: Scalars['Boolean'];
  id: Scalars['ID'];
  locale?: Maybe<Locale>;
  mimeType: Scalars['String'];
  name: Scalars['String'];
  path: Scalars['String'];
  shareWithChildBranches: Scalars['Boolean'];
  updatedAt: Scalars['Timestamp'];
  url: Scalars['String'];
  user?: Maybe<Profile>;
};

export type MediaDocumentType = ApiNode & OwnedApiNode & {
  __typename: 'MediaDocumentType';
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  code: Scalars['String'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  defaultMedia?: Maybe<Media>;
  id: Scalars['ID'];
  name: Scalars['String'];
  shareWithChildBranches: Scalars['Boolean'];
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type MediaDocumentTypeInput = {
  code?: InputMaybe<Scalars['String']>;
  defaultMediaId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type MediaInput = {
  altText?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
  global?: Scalars['Boolean'];
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Locale>;
  name?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename: 'Mutation';
  addOrganizer: Organizer;
  createOrganizationUser: Profile;
  createUser: Profile;
  decodeAndFindLocale: InvitePatient;
  decodeAndUpdateResponse: InvitePatient;
  deleteNode?: Maybe<RemovedNode>;
  deleteNodeOrganizationUsers?: Maybe<RemovedNode>;
  /** Deletes a Media record only if is not global */
  deleteNotGlobalMedia?: Maybe<RemovedNode>;
  importEvents: EventImport;
  loginToken: LoginResponse;
  mutateAclRole: AclRole;
  mutateCalendar: Calendar;
  mutateCancelCustomDomainNameRequest: CustomDomainNameRequest;
  mutateCustomDomainNameRequest: CustomDomainNameRequest;
  mutateEvent: CalendarEvent;
  mutateEventAttendee: EventAttendee;
  mutateEventAttendeeAttendance: EventAttendee;
  mutateEventCategory: EventCategory;
  mutateEventImport: EventImport;
  mutateEventType: EventType;
  mutateInProgressCustomDomainNameRequest: CustomDomainNameRequest;
  mutateMedia: Media;
  mutateMediaDocumentType: MediaDocumentType;
  mutateNodeBranch: OwnedApiNode;
  mutateNotificationTemplate: NotificationTemplate;
  mutateNotificationTemplateDefault: NotificationTemplateDefaultResponse;
  mutateOrganizationBranch: OrganizationBranch;
  mutateOrganizationUser: Profile;
  mutateOrganizer: Organizer;
  mutatePathway: Pathway;
  mutatePathwayItem: PathwayItem;
  mutateProfile: Profile;
  mutateSetting: Setting;
  mutateViewer: Profile;
  refreshToken: LoginResponse;
  /** Request a password reset through email. If the email is not active yet, a validation email is sent instead */
  requestPasswordReset: Scalars['Boolean'];
  resetPassword: Profile;
  toggleSelectedCalendar?: Maybe<Array<Maybe<Scalars['ID']>>>;
  validateEmail: EmailValidationResponse;
};


export type MutationaddOrganizerArgs = {
  input: OrganizerInput;
};


export type MutationcreateOrganizationUserArgs = {
  input: NewOrganizationUserInput;
};


export type MutationcreateUserArgs = {
  input: NewUserInput;
};


export type MutationdecodeAndFindLocaleArgs = {
  input: TokenInvitePatientInput;
};


export type MutationdecodeAndUpdateResponseArgs = {
  input: TokenInvitePatientInput;
};


export type MutationdeleteNodeArgs = {
  input: NodeSelectInput;
};


export type MutationdeleteNodeOrganizationUsersArgs = {
  input: NodeSelectInput;
};


export type MutationdeleteNotGlobalMediaArgs = {
  input: NodeSelectInput;
};


export type MutationimportEventsArgs = {
  eventImportId: Scalars['ID'];
};


export type MutationloginTokenArgs = {
  input: LoginInput;
};


export type MutationmutateAclRoleArgs = {
  input: AclRoleInput;
};


export type MutationmutateCalendarArgs = {
  input: CalendarInput;
};


export type MutationmutateCancelCustomDomainNameRequestArgs = {
  input: NodeSelectInput;
};


export type MutationmutateCustomDomainNameRequestArgs = {
  input: CustomDomainNameRequestInput;
};


export type MutationmutateEventArgs = {
  input: EventInput;
};


export type MutationmutateEventAttendeeArgs = {
  input: EventAttendeeInput;
};


export type MutationmutateEventAttendeeAttendanceArgs = {
  input: EventAttendeeAttendanceInput;
};


export type MutationmutateEventCategoryArgs = {
  input: EventCategoryInput;
};


export type MutationmutateEventImportArgs = {
  input: EventImportInput;
};


export type MutationmutateEventTypeArgs = {
  input: EventTypeInput;
};


export type MutationmutateInProgressCustomDomainNameRequestArgs = {
  input: NodeSelectInput;
};


export type MutationmutateMediaArgs = {
  input: MediaInput;
};


export type MutationmutateMediaDocumentTypeArgs = {
  input: MediaDocumentTypeInput;
};


export type MutationmutateNodeBranchArgs = {
  input: NodeBranchInput;
};


export type MutationmutateNotificationTemplateArgs = {
  input: NotificationTemplateInput;
};


export type MutationmutateNotificationTemplateDefaultArgs = {
  input: NotificationTemplateDefaultInput;
};


export type MutationmutateOrganizationBranchArgs = {
  input: OrganizationBranchInput;
};


export type MutationmutateOrganizationUserArgs = {
  input: OrganizationUserEditInput;
};


export type MutationmutateOrganizerArgs = {
  input: OrganizerInput;
};


export type MutationmutatePathwayArgs = {
  input: PathwayInput;
};


export type MutationmutatePathwayItemArgs = {
  input: PathwayItemInput;
};


export type MutationmutateProfileArgs = {
  input: ProfileEditInput;
};


export type MutationmutateSettingArgs = {
  input: SettingInput;
};


export type MutationmutateViewerArgs = {
  input: ViewerEditInput;
};


export type MutationrefreshTokenArgs = {
  input: RefreshInput;
};


export type MutationrequestPasswordResetArgs = {
  input: Scalars['String'];
};


export type MutationresetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationtoggleSelectedCalendarArgs = {
  id: Scalars['ID'];
};


export type MutationvalidateEmailArgs = {
  input: Scalars['String'];
};

export type NewOrganizationUserInput = {
  aclRolesIds: Array<Scalars['ID']>;
  active: Scalars['Boolean'];
  email: Scalars['String'];
  locale?: InputMaybe<Locale>;
  mergeAccount?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organizationBranchId?: InputMaybe<Scalars['ID']>;
  password?: InputMaybe<Scalars['String']>;
  tzname?: InputMaybe<Scalars['String']>;
};

export type NewUserInput = {
  email: Scalars['String'];
  locale?: InputMaybe<Locale>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  tzname?: InputMaybe<Scalars['String']>;
};

export type NodeBranchFilterInput = {
  branch_ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type NodeBranchInput = {
  branch_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  shareWithChildBranches?: InputMaybe<Scalars['Boolean']>;
};

export type NodeIdentifier = {
  id: Scalars['ID'];
};

export type NodeInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type NodeMedia = ApiNode & {
  __typename: 'NodeMedia';
  _id: Scalars['Float'];
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  documentType?: Maybe<MediaDocumentType>;
  file: Media;
  id: Scalars['ID'];
  node: ApiNode;
  nodeId: Scalars['String'];
  updatedAt: Scalars['Timestamp'];
};

export type NodeMediaInput = {
  documentTypeId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  id_media: Scalars['ID'];
};

export type NodeSelectInput = {
  id: Scalars['ID'];
};

export type NodeTag = {
  _id: Scalars['Float'];
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  key: Scalars['String'];
  updatedAt: Scalars['Timestamp'];
  value: Scalars['String'];
};

export type NodeTagInput = {
  id?: InputMaybe<Scalars['ID']>;
  key: Scalars['String'];
  value: Scalars['String'];
};

export type NodeWithFiles = {
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  files: Array<NodeMedia>;
  id: Scalars['ID'];
  shareWithChildBranches: Scalars['Boolean'];
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type NotificationData = ApiNode & {
  __typename: 'NotificationData';
  _id: Scalars['Float'];
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  data?: Maybe<Scalars['String']>;
  destination: Scalars['String'];
  id: Scalars['ID'];
  locale: Locale;
  method: NotificationMethod;
  modelId: Scalars['ID'];
  template?: Maybe<NotificationTemplate>;
  type: NotificationType;
  updatedAt: Scalars['Timestamp'];
};

/** NotificationData methods */
export enum NotificationMethod {
  EMAIL = 'EMAIL'
}

export type NotificationQueue = ApiNode & {
  __typename: 'NotificationQueue';
  _id: Scalars['Float'];
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  log?: Maybe<Scalars['String']>;
  notification: NotificationData;
  readAt?: Maybe<Scalars['Timestamp']>;
  schedule?: Maybe<Scalars['Timestamp']>;
  send: Scalars['Boolean'];
  sendAt?: Maybe<Scalars['Timestamp']>;
  success: Scalars['Boolean'];
  template: NotificationTemplate;
  updatedAt: Scalars['Timestamp'];
};

export type NotificationTemplate = ApiNode & OwnedApiNode & {
  __typename: 'NotificationTemplate';
  _id: Scalars['Float'];
  active: Scalars['Boolean'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  default: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  locales: Array<NotificationTemplateLocale>;
  method: NotificationMethod;
  public: Scalars['Boolean'];
  shareWithChildBranches: Scalars['Boolean'];
  subject: Scalars['String'];
  title: Scalars['String'];
  type: NotificationType;
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type NotificationTemplateDefaultInput = {
  id?: InputMaybe<Scalars['ID']>;
  method: NotificationMethod;
  type: NotificationType;
};

export type NotificationTemplateDefaultResponse = {
  __typename: 'NotificationTemplateDefaultResponse';
  method: NotificationMethod;
  nodeId?: Maybe<Scalars['String']>;
  type: NotificationType;
};

export type NotificationTemplateInput = {
  active?: Scalars['Boolean'];
  code?: InputMaybe<Scalars['String']>;
  content: Scalars['String'];
  default?: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  method?: NotificationMethod;
  subject: Scalars['String'];
  template_locales?: Array<NotificationTemplateLocaleInput>;
  title: Scalars['String'];
  type: NotificationType;
};

export type NotificationTemplateLocale = ApiNode & {
  __typename: 'NotificationTemplateLocale';
  _id: Scalars['Float'];
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  content: Scalars['String'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  locale: Locale;
  subject: Scalars['String'];
  template: NotificationTemplate;
  updatedAt: Scalars['Timestamp'];
};

export type NotificationTemplateLocaleInput = {
  content: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  locale: Locale;
  subject: Scalars['String'];
};

/** NotificationData types */
export enum NotificationType {
  ACCOUNT_EMAIL_CHANGED = 'ACCOUNT_EMAIL_CHANGED',
  ACCOUNT_PASSWORD_RESET = 'ACCOUNT_PASSWORD_RESET',
  ACCOUNT_USER_CREATED = 'ACCOUNT_USER_CREATED',
  ATTENDEE_ATTENDEE_INVITED = 'ATTENDEE_ATTENDEE_INVITED',
  ATTENDEE_ATTENDEE_INVITED_ACCEPT_ORGANIZER_INFORM = 'ATTENDEE_ATTENDEE_INVITED_ACCEPT_ORGANIZER_INFORM',
  ATTENDEE_ATTENDEE_INVITED_ORGANIZER_INFORM = 'ATTENDEE_ATTENDEE_INVITED_ORGANIZER_INFORM',
  ATTENDEE_ATTENDEE_REGISTERED = 'ATTENDEE_ATTENDEE_REGISTERED',
  ATTENDEE_ATTENDEE_REJECTED = 'ATTENDEE_ATTENDEE_REJECTED',
  ATTENDEE_ATTENDEE_REJECTED_ORGANIZERS = 'ATTENDEE_ATTENDEE_REJECTED_ORGANIZERS',
  ATTENDEE_EVENT_CANCELLED = 'ATTENDEE_EVENT_CANCELLED',
  ATTENDEE_EVENT_CUSTOM = 'ATTENDEE_EVENT_CUSTOM',
  ATTENDEE_EVENT_DATE_CHANGED = 'ATTENDEE_EVENT_DATE_CHANGED',
  ATTENDEE_EVENT_FINISHED = 'ATTENDEE_EVENT_FINISHED',
  ATTENDEE_EVENT_REMINDER = 'ATTENDEE_EVENT_REMINDER',
  ATTENDEE_INVITATION_ACCEPTANCE_REMINDER = 'ATTENDEE_INVITATION_ACCEPTANCE_REMINDER'
}

/** Organization branches */
export type OrganizationBranch = ApiNode & {
  __typename: 'OrganizationBranch';
  _id: Scalars['Float'];
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  children: Array<OrganizationBranch>;
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<OrganizationBranch>;
  parentId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['Timestamp'];
  user: Profile;
};

export type OrganizationBranchInput = {
  id?: InputMaybe<Scalars['ID']>;
  id_parent?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type OrganizationUserEditInput = {
  aclRolesIds: Array<Scalars['ID']>;
  active: Scalars['Boolean'];
  email: Scalars['String'];
  id: Scalars['ID'];
  locale?: InputMaybe<Locale>;
  name?: InputMaybe<Scalars['String']>;
  organizationBranchId?: InputMaybe<Scalars['ID']>;
  password?: InputMaybe<Scalars['String']>;
  tzname?: InputMaybe<Scalars['String']>;
};

export type Organizer = ApiNode & OwnedApiNode & {
  __typename: 'Organizer';
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  comments?: Maybe<Scalars['String']>;
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  shareWithChildBranches: Scalars['Boolean'];
  surname?: Maybe<Scalars['String']>;
  trainer: Scalars['Boolean'];
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type OrganizerInput = {
  comments?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  surname?: InputMaybe<Scalars['String']>;
  trainer?: InputMaybe<Scalars['Boolean']>;
};

export type OwnedApiNode = {
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  id: Scalars['ID'];
  shareWithChildBranches: Scalars['Boolean'];
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type Pathway = ApiNode & OwnedApiNode & {
  __typename: 'Pathway';
  _id: Scalars['Float'];
  accessType: EventAccessType;
  active: Scalars['Boolean'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['Int']>;
  events: Array<CalendarEvent>;
  files: Array<NodeMedia>;
  id: Scalars['ID'];
  items: Array<PathwayItem>;
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  notificationTemplates: Array<EventNotificationTemplate>;
  registrationRequired: Scalars['Boolean'];
  rootItems: Array<PathwayItem>;
  shareWithChildBranches: Scalars['Boolean'];
  start: Scalars['Int'];
  tags: Array<PathwayTag>;
  title: Scalars['String'];
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type PathwayInput = {
  accessType?: EventAccessType;
  active?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  registrationRequired?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['Float'];
  tags?: InputMaybe<Array<NodeTagInput>>;
  title: Scalars['String'];
};

export type PathwayItem = ApiNode & {
  __typename: 'PathwayItem';
  _id: Scalars['Float'];
  allChildrenIDs: Array<Scalars['ID']>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  children: Array<PathwayItem>;
  createdAt: Scalars['Timestamp'];
  event: CalendarEvent;
  id: Scalars['ID'];
  parent?: Maybe<PathwayItem>;
  pathway: Pathway;
  updatedAt: Scalars['Timestamp'];
};

export type PathwayItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  id_event: Scalars['ID'];
  id_parent_pathway?: InputMaybe<Scalars['ID']>;
  id_pathway: Scalars['ID'];
};

export type PathwayNotificationTemplate = ApiNode & OwnedApiNode & RelatedNotificationTemplate & {
  __typename: 'PathwayNotificationTemplate';
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  id: Scalars['ID'];
  method: NotificationMethod;
  node: Pathway;
  notification: NotificationTemplate;
  shareWithChildBranches: Scalars['Boolean'];
  type: NotificationType;
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type PathwayTag = ApiNode & NodeTag & {
  __typename: 'PathwayTag';
  _id: Scalars['Float'];
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  id: Scalars['ID'];
  key: Scalars['String'];
  node: Pathway;
  updatedAt: Scalars['Timestamp'];
  value: Scalars['String'];
};

export type Profile = ApiNode & OwnedApiNode & {
  __typename: 'Profile';
  _id: Scalars['Float'];
  /** Merged ACL rules */
  acl: Scalars['String'];
  aclRoles: Array<AclRole>;
  active: Scalars['Boolean'];
  attendeeTo: Array<EventAttendee>;
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  email: Scalars['String'];
  id: Scalars['ID'];
  isEmailActive: Scalars['Boolean'];
  isOrganization: Scalars['Boolean'];
  locale: Locale;
  name: Scalars['String'];
  organization?: Maybe<Profile>;
  organizationBranch?: Maybe<OrganizationBranch>;
  /** Not entity dependent permissions */
  permissions: Array<AclPermissionsRow>;
  remoteSource?: Maybe<Scalars['String']>;
  role: Role;
  shareWithChildBranches: Scalars['Boolean'];
  tzname: Scalars['String'];
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
  username: Scalars['String'];
};

export type ProfileEditInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  locale?: InputMaybe<Locale>;
  name?: InputMaybe<Scalars['String']>;
  tzname?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename: 'Query';
  aclRoles: Array<AclRole>;
  calendars: Array<Calendar>;
  cities: Array<City>;
  city: City;
  constants: Constants;
  event: CalendarEvent;
  eventAttendees: Array<EventAttendee>;
  eventCategories: Array<EventCategory>;
  eventImport: EventImport;
  eventImports: Array<EventImport>;
  /** Retrieve public events for external clients to browse */
  eventSearch: Array<CalendarEvent>;
  /** Retrieve user's own events to show on the calendar ui */
  events: Array<CalendarEvent>;
  eventsCities: Array<City>;
  eventsCountries: Array<Scalars['String']>;
  /** Retrieve user's own events to show on the calendar ui */
  eventsExport: Array<CalendarEvent>;
  eventsTypes: Array<EventType>;
  getCustomDomainNameRequest: CustomDomainNameRequest;
  media: Media;
  mediaAccessUrl: UrlResponse;
  mediaDocumentType: MediaDocumentType;
  mediaDocumentTypes: Array<MediaDocumentType>;
  medias: Array<Media>;
  nextPathwayEvent: Array<CalendarEvent>;
  node: ApiNode;
  nodeMediaAccessUrl: UrlResponse;
  notificationTemplate: NotificationTemplate;
  notificationTemplates: Array<NotificationTemplate>;
  organizationBranches: Array<OrganizationBranch>;
  organizationUsers: Array<Profile>;
  organizers: Array<Organizer>;
  organizerslocation: Array<Organizer>;
  pathway: Pathway;
  pathwayItems: Array<PathwayItem>;
  pathways: Array<Pathway>;
  publicNotificationTemplates: Array<NotificationTemplate>;
  resolvedEventFiles: Array<ResolvedEventFile>;
  selectedCalendars: Array<Maybe<Scalars['ID']>>;
  settings: Array<Setting>;
  state?: Maybe<LocalState>;
  tagNames: Array<Scalars['String']>;
  tagValues: Array<Scalars['String']>;
  userBranches: Array<OrganizationBranch>;
  viewer?: Maybe<Profile>;
};


export type QueryaclRolesArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
};


export type QuerycalendarsArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
};


export type QuerycitiesArgs = {
  input?: CitySearchQueryInput;
};


export type QuerycityArgs = {
  id: Scalars['ID'];
};


export type QueryeventArgs = {
  id: Scalars['ID'];
};


export type QueryeventAttendeesArgs = {
  id: Scalars['String'];
};


export type QueryeventCategoriesArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
};


export type QueryeventImportArgs = {
  id: Scalars['ID'];
};


export type QueryeventImportsArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
};


export type QueryeventSearchArgs = {
  input: EventSearchQuery;
};


export type QueryeventsArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
  input: EventSearchQuery;
};


export type QueryeventsCitiesArgs = {
  input: EventSearchQuery;
};


export type QueryeventsCountriesArgs = {
  input: EventSearchQuery;
};


export type QueryeventsExportArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
  input: EventSearchQuery;
};


export type QueryeventsTypesArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
};


export type QuerymediaArgs = {
  id: Scalars['ID'];
};


export type QuerymediaAccessUrlArgs = {
  id: Scalars['ID'];
};


export type QuerymediaDocumentTypeArgs = {
  id: Scalars['ID'];
};


export type QuerymediaDocumentTypesArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
};


export type QuerymediasArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
  nodeId?: InputMaybe<Scalars['String']>;
};


export type QuerynextPathwayEventArgs = {
  id: Scalars['ID'];
};


export type QuerynodeArgs = {
  input: NodeSelectInput;
};


export type QuerynodeMediaAccessUrlArgs = {
  id: Scalars['ID'];
};


export type QuerynotificationTemplateArgs = {
  id: Scalars['ID'];
};


export type QuerynotificationTemplatesArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
};


export type QueryorganizationUsersArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
};


export type QueryorganizersArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
};


export type QueryorganizerslocationArgs = {
  input: OrganizerInput;
};


export type QuerypathwayArgs = {
  id: Scalars['ID'];
};


export type QuerypathwayItemsArgs = {
  input: NodeSelectInput;
};


export type QuerypathwaysArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
};


export type QueryresolvedEventFilesArgs = {
  eventTypeId?: InputMaybe<Scalars['ID']>;
};


export type QuerysettingsArgs = {
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
};


export type QuerytagValuesArgs = {
  tagKey: Scalars['String'];
};

export type Recurrence = ApiNode & {
  __typename: 'Recurrence';
  _id: Scalars['Float'];
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  end?: Maybe<Scalars['Int']>;
  generatedUntil: Scalars['Int'];
  hasMore: Scalars['Boolean'];
  id: Scalars['ID'];
  occurrences: Array<CalendarEvent>;
  rrule?: Maybe<Scalars['String']>;
  start: Scalars['Int'];
  type: RecurrenceType;
  updatedAt: Scalars['Timestamp'];
};

export type RecurrenceInput = {
  occurrences?: InputMaybe<Array<StaticEventOccurrenceInput>>;
  rrule?: InputMaybe<Scalars['String']>;
  type?: RecurrenceType;
};

/** Type of recurrence */
export enum RecurrenceType {
  No_Recurrence = 'No_Recurrence',
  RRule_Recurrence = 'RRule_Recurrence',
  Static_Recurrence = 'Static_Recurrence'
}

/** How to update recurrenceType events */
export enum RecurrenceUpdateMode {
  Update_All = 'Update_All',
  Update_Backward = 'Update_Backward',
  Update_Forward = 'Update_Forward',
  Update_Single = 'Update_Single'
}

export type RefreshInput = {
  clientId: Scalars['String'];
  clientSecret?: InputMaybe<Scalars['String']>;
  refreshToken: Scalars['String'];
};

export type RelatedNotificationTemplate = {
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  id: Scalars['ID'];
  method: NotificationMethod;
  notification: NotificationTemplate;
  shareWithChildBranches: Scalars['Boolean'];
  type: NotificationType;
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type ReminderItem = {
  __typename: 'ReminderItem';
  offset: Scalars['Float'];
  template?: Maybe<Scalars['String']>;
};

export type ReminderItemInput = {
  offset: Scalars['Float'];
  template?: InputMaybe<Scalars['String']>;
};

export type RemovedNode = {
  __typename: 'RemovedNode';
  id: Scalars['ID'];
};

export type ResetPasswordInput = {
  newPassword: Scalars['String'];
  token: Scalars['String'];
};

export type ResolvedEventFile = {
  __typename: 'ResolvedEventFile';
  documentTypeId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  id_media: Scalars['ID'];
  source?: Maybe<Scalars['String']>;
};

/** User roles */
export enum Role {
  Admin = 'Admin',
  Guest = 'Guest',
  User = 'User'
}

export type Setting = ApiNode & OwnedApiNode & {
  __typename: 'Setting';
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  id: Scalars['ID'];
  key: SettingKey;
  shareWithChildBranches: Scalars['Boolean'];
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
  value: Scalars['String'];
};

export type SettingInput = {
  key: SettingKey;
  value: Scalars['String'];
};

/** Available settings keys */
export enum SettingKey {
  DEFAULT_CALENDAR = 'DEFAULT_CALENDAR',
  FROM_EMAIL = 'FROM_EMAIL',
  FROM_NAME = 'FROM_NAME',
  SMTP_URL = 'SMTP_URL'
}

export type StaticEventOccurrenceInput = {
  id?: InputMaybe<Scalars['ID']>;
  start: Scalars['Float'];
};

export type TokenInvitePatientInput = {
  actionResponse: Scalars['String'];
  emailDE?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

export type UrlResponse = {
  __typename: 'UrlResponse';
  expiration: Scalars['Float'];
  issued: Scalars['Float'];
  media: Media;
  url: Scalars['String'];
};

export type UserActionLog = ApiNode & OwnedApiNode & {
  __typename: 'UserActionLog';
  _id: Scalars['Float'];
  branch?: Maybe<OrganizationBranch>;
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  createdAt: Scalars['Timestamp'];
  creator?: Maybe<Profile>;
  id: Scalars['ID'];
  input: Scalars['String'];
  operationName: Scalars['String'];
  output: Scalars['String'];
  shareWithChildBranches: Scalars['Boolean'];
  updatedAt: Scalars['Timestamp'];
  user?: Maybe<Profile>;
};

export type ViewerEditInput = {
  email?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Locale>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  tzname?: InputMaybe<Scalars['String']>;
};

export type AclRoleDataFragment = { __typename: 'AclRole', id: string, name: string, active: boolean, acl: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user: { __typename: 'Profile', id: string, name: string }, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type aclRolesQueryVariables = Exact<{
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
}>;


export type aclRolesQuery = { __typename: 'Query', aclRoles: Array<{ __typename: 'AclRole', id: string, name: string, active: boolean, acl: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user: { __typename: 'Profile', id: string, name: string }, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }> };

export type AclRolesMutationMutationVariables = Exact<{
  input: AclRoleInput;
}>;


export type AclRolesMutationMutation = { __typename: 'Mutation', mutateAclRole: { __typename: 'AclRole', id: string, name: string, active: boolean, acl: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user: { __typename: 'Profile', id: string, name: string }, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type DeleteNodeMutationMutationVariables = Exact<{
  input: NodeSelectInput;
}>;


export type DeleteNodeMutationMutation = { __typename: 'Mutation', deleteNode?: { __typename: 'RemovedNode', id: string } | null };

export type DeleteNodeOrganizationUsersMutationMutationVariables = Exact<{
  input: NodeSelectInput;
}>;


export type DeleteNodeOrganizationUsersMutationMutation = { __typename: 'Mutation', deleteNodeOrganizationUsers?: { __typename: 'RemovedNode', id: string } | null };

export type GetNodePermissionsQueryVariables = Exact<{
  input: NodeSelectInput;
}>;


export type GetNodePermissionsQuery = { __typename: 'Query', node: { __typename: 'AclRole', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'Calendar', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'CalendarEvent', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'City', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'CustomDomainNameDnsRecords', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'CustomDomainNameRequest', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'EventAttendee', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'EventCategory', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'EventImport', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'EventNotificationTemplate', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'EventTag', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'EventType', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'EventTypeNotificationTemplate', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'EventTypeTag', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'Media', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'MediaDocumentType', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'NodeMedia', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'NotificationData', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'NotificationQueue', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'NotificationTemplate', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'NotificationTemplateLocale', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'OrganizationBranch', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'Organizer', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'Pathway', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'PathwayItem', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'PathwayNotificationTemplate', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'PathwayTag', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'Profile', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'Recurrence', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'Setting', id: string, canBeDeleted: boolean, canBeUpdated: boolean } | { __typename: 'UserActionLog', id: string, canBeDeleted: boolean, canBeUpdated: boolean } };

export type EventRecurrenceDataFragment = { __typename: 'Recurrence', id: string, start: number, type: RecurrenceType, occurrences: Array<{ __typename: 'CalendarEvent', id: string, start: number }> };

export type CalendarEventBasicDataFragment = { __typename: 'CalendarEvent', id: string, title: string, description?: string | null, start: number, end: number, language: Array<string>, color: string, allDay: boolean, attendeeLimit: number, hasAttendeeRegistration: boolean, isOnline: boolean, isFinished: boolean, location?: string | null, locationName?: string | null, lat?: string | null, lng?: string | null, accessType: EventAccessType, recurrenceDate?: number | null, id_type?: string | null, id_calendar: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, attendees: Array<{ __typename: 'EventAttendee', id: string, type: AttendeeType, confirmed: boolean, attended: boolean, message?: string | null, canBeDeleted: boolean, canBeUpdated: boolean, profile: { __typename: 'Profile', id: string, name: string, email: string }, event: { __typename: 'CalendarEvent', id: string, title: string } }>, calendar: { __typename: 'Calendar', id: string, name: string, color: string }, organizers: Array<{ __typename: 'Organizer', id: string, email?: string | null }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type CalendarEventDataFragment = { __typename: 'CalendarEvent', id: string, title: string, description?: string | null, start: number, end: number, language: Array<string>, color: string, allDay: boolean, attendeeLimit: number, hasAttendeeRegistration: boolean, isOnline: boolean, isFinished: boolean, location?: string | null, locationName?: string | null, lat?: string | null, lng?: string | null, accessType: EventAccessType, recurrenceDate?: number | null, id_type?: string | null, id_calendar: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, recurrence?: { __typename: 'Recurrence', id: string, start: number, type: RecurrenceType, occurrences: Array<{ __typename: 'CalendarEvent', id: string, start: number }> } | null, tags: Array<{ __typename: 'EventTag', id: string, key: string, value: string }>, files: Array<{ __typename: 'NodeMedia', canBeDeleted: boolean, canBeUpdated: boolean, id: string, nodeId: string, documentType?: { __typename: 'MediaDocumentType', name: string, code: string, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, defaultMedia?: { __typename: 'Media', id: string, filename: string, mimeType: string, name: string } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | null, file: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } }>, notificationTemplates: Array<{ __typename: 'EventNotificationTemplate', id: string, notification: { __typename: 'NotificationTemplate', id: string } }>, featuredImage?: { __typename: 'Media', id: string } | null, eventImport?: { __typename: 'EventImport', name: string, id: string } | null, reminders?: Array<{ __typename: 'ReminderItem', offset: number, template?: string | null }> | null, organizers: Array<{ __typename: 'Organizer', id: string, email?: string | null }>, attendees: Array<{ __typename: 'EventAttendee', id: string, type: AttendeeType, confirmed: boolean, attended: boolean, message?: string | null, canBeDeleted: boolean, canBeUpdated: boolean, profile: { __typename: 'Profile', id: string, name: string, email: string }, event: { __typename: 'CalendarEvent', id: string, title: string } }>, calendar: { __typename: 'Calendar', id: string, name: string, color: string }, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type CalendarEventExportDataFragment = { __typename: 'CalendarEvent', id: string, title: string, start: number, end: number, allDay: boolean, isOnline: boolean, location?: string | null, locationName?: string | null, language: Array<string>, attendeeLimit: number, id_type?: string | null, attendees: Array<{ __typename: 'EventAttendee', attended: boolean, profile: { __typename: 'Profile', email: string } }>, branch?: { __typename: 'OrganizationBranch', name: string } | null, organizers: Array<{ __typename: 'Organizer', email?: string | null }> };

export type eventsQueryVariables = Exact<{
  fromDate: Scalars['Int'];
  toDate: Scalars['Int'];
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
}>;


export type eventsQuery = { __typename: 'Query', events: Array<{ __typename: 'CalendarEvent', id: string, title: string, description?: string | null, start: number, end: number, language: Array<string>, color: string, allDay: boolean, attendeeLimit: number, hasAttendeeRegistration: boolean, isOnline: boolean, isFinished: boolean, location?: string | null, locationName?: string | null, lat?: string | null, lng?: string | null, accessType: EventAccessType, recurrenceDate?: number | null, id_type?: string | null, id_calendar: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, attendees: Array<{ __typename: 'EventAttendee', id: string, type: AttendeeType, confirmed: boolean, attended: boolean, message?: string | null, canBeDeleted: boolean, canBeUpdated: boolean, profile: { __typename: 'Profile', id: string, name: string, email: string }, event: { __typename: 'CalendarEvent', id: string, title: string } }>, calendar: { __typename: 'Calendar', id: string, name: string, color: string }, organizers: Array<{ __typename: 'Organizer', id: string, email?: string | null }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }> };

export type eventsExportQueryVariables = Exact<{
  fromDate: Scalars['Int'];
  toDate: Scalars['Int'];
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
}>;


export type eventsExportQuery = { __typename: 'Query', events: Array<{ __typename: 'CalendarEvent', id: string, title: string, start: number, end: number, allDay: boolean, isOnline: boolean, location?: string | null, locationName?: string | null, language: Array<string>, attendeeLimit: number, id_type?: string | null, attendees: Array<{ __typename: 'EventAttendee', attended: boolean, profile: { __typename: 'Profile', email: string } }>, branch?: { __typename: 'OrganizationBranch', name: string } | null, organizers: Array<{ __typename: 'Organizer', email?: string | null }> }> };

export type eventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type eventQuery = { __typename: 'Query', event: { __typename: 'CalendarEvent', id: string, title: string, description?: string | null, start: number, end: number, language: Array<string>, color: string, allDay: boolean, attendeeLimit: number, hasAttendeeRegistration: boolean, isOnline: boolean, isFinished: boolean, location?: string | null, locationName?: string | null, lat?: string | null, lng?: string | null, accessType: EventAccessType, recurrenceDate?: number | null, id_type?: string | null, id_calendar: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, recurrence?: { __typename: 'Recurrence', id: string, start: number, type: RecurrenceType, occurrences: Array<{ __typename: 'CalendarEvent', id: string, start: number }> } | null, tags: Array<{ __typename: 'EventTag', id: string, key: string, value: string }>, files: Array<{ __typename: 'NodeMedia', canBeDeleted: boolean, canBeUpdated: boolean, id: string, nodeId: string, documentType?: { __typename: 'MediaDocumentType', name: string, code: string, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, defaultMedia?: { __typename: 'Media', id: string, filename: string, mimeType: string, name: string } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | null, file: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } }>, notificationTemplates: Array<{ __typename: 'EventNotificationTemplate', id: string, notification: { __typename: 'NotificationTemplate', id: string } }>, featuredImage?: { __typename: 'Media', id: string } | null, eventImport?: { __typename: 'EventImport', name: string, id: string } | null, reminders?: Array<{ __typename: 'ReminderItem', offset: number, template?: string | null }> | null, organizers: Array<{ __typename: 'Organizer', id: string, email?: string | null }>, attendees: Array<{ __typename: 'EventAttendee', id: string, type: AttendeeType, confirmed: boolean, attended: boolean, message?: string | null, canBeDeleted: boolean, canBeUpdated: boolean, profile: { __typename: 'Profile', id: string, name: string, email: string }, event: { __typename: 'CalendarEvent', id: string, title: string } }>, calendar: { __typename: 'Calendar', id: string, name: string, color: string }, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type EventMutationMutationVariables = Exact<{
  input: EventInput;
}>;


export type EventMutationMutation = { __typename: 'Mutation', mutateEvent: { __typename: 'CalendarEvent', id: string, title: string, description?: string | null, start: number, end: number, language: Array<string>, color: string, allDay: boolean, attendeeLimit: number, hasAttendeeRegistration: boolean, isOnline: boolean, isFinished: boolean, location?: string | null, locationName?: string | null, lat?: string | null, lng?: string | null, accessType: EventAccessType, recurrenceDate?: number | null, id_type?: string | null, id_calendar: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, recurrence?: { __typename: 'Recurrence', id: string, start: number, type: RecurrenceType, occurrences: Array<{ __typename: 'CalendarEvent', id: string, start: number }> } | null, tags: Array<{ __typename: 'EventTag', id: string, key: string, value: string }>, files: Array<{ __typename: 'NodeMedia', canBeDeleted: boolean, canBeUpdated: boolean, id: string, nodeId: string, documentType?: { __typename: 'MediaDocumentType', name: string, code: string, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, defaultMedia?: { __typename: 'Media', id: string, filename: string, mimeType: string, name: string } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | null, file: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } }>, notificationTemplates: Array<{ __typename: 'EventNotificationTemplate', id: string, notification: { __typename: 'NotificationTemplate', id: string } }>, featuredImage?: { __typename: 'Media', id: string } | null, eventImport?: { __typename: 'EventImport', name: string, id: string } | null, reminders?: Array<{ __typename: 'ReminderItem', offset: number, template?: string | null }> | null, organizers: Array<{ __typename: 'Organizer', id: string, email?: string | null }>, attendees: Array<{ __typename: 'EventAttendee', id: string, type: AttendeeType, confirmed: boolean, attended: boolean, message?: string | null, canBeDeleted: boolean, canBeUpdated: boolean, profile: { __typename: 'Profile', id: string, name: string, email: string }, event: { __typename: 'CalendarEvent', id: string, title: string } }>, calendar: { __typename: 'Calendar', id: string, name: string, color: string }, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type resolvedEventFilesQueryVariables = Exact<{
  eventTypeId?: InputMaybe<Scalars['ID']>;
}>;


export type resolvedEventFilesQuery = { __typename: 'Query', resolvedEventFiles: Array<{ __typename: 'ResolvedEventFile', id?: string | null, id_media: string, documentTypeId?: string | null, source?: string | null }> };

export type CalendarInputFragment = { __typename: 'Calendar', id: string, name: string, color: string };

export type CalendarDataFragment = { __typename: 'Calendar', id: string, name: string, color: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type calendarsQueryVariables = Exact<{
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
}>;


export type calendarsQuery = { __typename: 'Query', calendars: Array<{ __typename: 'Calendar', id: string, name: string, color: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }> };

export type CalendarMutationMutationVariables = Exact<{
  input: CalendarInput;
}>;


export type CalendarMutationMutation = { __typename: 'Mutation', mutateCalendar: { __typename: 'Calendar', id: string, name: string, color: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type constantsQueryVariables = Exact<{ [key: string]: never; }>;


export type constantsQuery = { __typename: 'Query', constants: { __typename: 'Constants', locales: Array<Locale>, notificationMethods: Array<{ __typename: 'KeyValue', key: string, value: string }>, notificationTypes: Array<{ __typename: 'KeyValue', key: string, value: string }>, allNotificationTypes: Array<{ __typename: 'KeyValue', key: string, value: string }> } };

export type aclEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type aclEntitiesQuery = { __typename: 'Query', constants: { __typename: 'Constants', aclRolesEntities: Array<{ __typename: 'KeyValue', key: string, value: string }> } };

export type DomainInputFragment = { __typename: 'CustomDomainNameRequest', id: string, domainName: string, fromEmail: string, fromEmailName: string, status: CustomDomainRequestStatus, customDomainNameDnsRecords: Array<{ __typename: 'CustomDomainNameDnsRecords', id: string, type: DnsRecordType, name: string, value: string }> };

export type DomainDataFragment = { __typename: 'CustomDomainNameRequest', id: string, domainName: string, fromEmail: string, fromEmailName: string, status: CustomDomainRequestStatus, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, customDomainNameDnsRecords: Array<{ __typename: 'CustomDomainNameDnsRecords', id: string, type: DnsRecordType, name: string, value: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type getDomainQueryVariables = Exact<{ [key: string]: never; }>;


export type getDomainQuery = { __typename: 'Query', getCustomDomainNameRequest: { __typename: 'CustomDomainNameRequest', id: string, domainName: string, fromEmail: string, fromEmailName: string, status: CustomDomainRequestStatus, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, customDomainNameDnsRecords: Array<{ __typename: 'CustomDomainNameDnsRecords', id: string, type: DnsRecordType, name: string, value: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type DomainEditMutationVariables = Exact<{
  input: CustomDomainNameRequestInput;
}>;


export type DomainEditMutation = { __typename: 'Mutation', mutateCustomDomainNameRequest: { __typename: 'CustomDomainNameRequest', id: string, domainName: string, fromEmail: string, fromEmailName: string, status: CustomDomainRequestStatus, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, customDomainNameDnsRecords: Array<{ __typename: 'CustomDomainNameDnsRecords', id: string, type: DnsRecordType, name: string, value: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type DomainCancelMutationVariables = Exact<{
  input: NodeSelectInput;
}>;


export type DomainCancelMutation = { __typename: 'Mutation', mutateCancelCustomDomainNameRequest: { __typename: 'CustomDomainNameRequest', id: string, domainName: string, fromEmail: string, fromEmailName: string, status: CustomDomainRequestStatus, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, customDomainNameDnsRecords: Array<{ __typename: 'CustomDomainNameDnsRecords', id: string, type: DnsRecordType, name: string, value: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type DomainInProgressMutationVariables = Exact<{
  input: NodeSelectInput;
}>;


export type DomainInProgressMutation = { __typename: 'Mutation', mutateInProgressCustomDomainNameRequest: { __typename: 'CustomDomainNameRequest', id: string, domainName: string, fromEmail: string, fromEmailName: string, status: CustomDomainRequestStatus, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, customDomainNameDnsRecords: Array<{ __typename: 'CustomDomainNameDnsRecords', id: string, type: DnsRecordType, name: string, value: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type EventAttendeeDataFragment = { __typename: 'EventAttendee', id: string, type: AttendeeType, confirmed: boolean, attended: boolean, message?: string | null, canBeDeleted: boolean, canBeUpdated: boolean, profile: { __typename: 'Profile', id: string, name: string, email: string }, event: { __typename: 'CalendarEvent', id: string, title: string } };

export type AttendanceMutationMutationVariables = Exact<{
  input: EventAttendeeAttendanceInput;
}>;


export type AttendanceMutationMutation = { __typename: 'Mutation', mutateEventAttendeeAttendance: { __typename: 'EventAttendee', id: string, type: AttendeeType, confirmed: boolean, attended: boolean, message?: string | null, canBeDeleted: boolean, canBeUpdated: boolean, profile: { __typename: 'Profile', id: string, name: string, email: string }, event: { __typename: 'CalendarEvent', id: string, title: string } } };

export type AttendeeMutationMutationVariables = Exact<{
  input: EventAttendeeInput;
}>;


export type AttendeeMutationMutation = { __typename: 'Mutation', mutateEventAttendee: { __typename: 'EventAttendee', id: string, type: AttendeeType, confirmed: boolean, attended: boolean, message?: string | null, canBeDeleted: boolean, canBeUpdated: boolean, profile: { __typename: 'Profile', id: string, name: string, email: string }, event: { __typename: 'CalendarEvent', id: string, title: string } } };

export type attendeesQueryVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type attendeesQuery = { __typename: 'Query', eventAttendees: Array<{ __typename: 'EventAttendee', id: string, type: AttendeeType, confirmed: boolean, attended: boolean, message?: string | null, canBeDeleted: boolean, canBeUpdated: boolean, profile: { __typename: 'Profile', id: string, name: string, email: string }, event: { __typename: 'CalendarEvent', id: string, title: string } }> };

export type DecodeAndUpdateResponseMutationVariables = Exact<{
  input: TokenInvitePatientInput;
}>;


export type DecodeAndUpdateResponseMutation = { __typename: 'Mutation', decodeAndUpdateResponse: { __typename: 'InvitePatient', response: string } };

export type DecodeAndFindLocaleMutationVariables = Exact<{
  input: TokenInvitePatientInput;
}>;


export type DecodeAndFindLocaleMutation = { __typename: 'Mutation', decodeAndFindLocale: { __typename: 'InvitePatient', response: string } };

export type EventImportDataFragment = { __typename: 'EventImport', id: string, name: string, log?: string | null, state: EventImportState, tzname?: string | null, dateFormat?: string | null, geolocateLocation?: boolean | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, file: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type eventImportsQueryVariables = Exact<{
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
}>;


export type eventImportsQuery = { __typename: 'Query', eventImports: Array<{ __typename: 'EventImport', id: string, name: string, log?: string | null, state: EventImportState, tzname?: string | null, dateFormat?: string | null, geolocateLocation?: boolean | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, file: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }> };

export type EventImportMutationMutationVariables = Exact<{
  input: EventImportInput;
}>;


export type EventImportMutationMutation = { __typename: 'Mutation', mutateEventImport: { __typename: 'EventImport', id: string, name: string, log?: string | null, state: EventImportState, tzname?: string | null, dateFormat?: string | null, geolocateLocation?: boolean | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, file: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type DoEventImportMutationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DoEventImportMutationMutation = { __typename: 'Mutation', importEvents: { __typename: 'EventImport', id: string, name: string, log?: string | null, state: EventImportState, tzname?: string | null, dateFormat?: string | null, geolocateLocation?: boolean | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, file: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type eventImportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type eventImportQuery = { __typename: 'Query', eventImport: { __typename: 'EventImport', id: string, name: string, log?: string | null, state: EventImportState, tzname?: string | null, dateFormat?: string | null, geolocateLocation?: boolean | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, file: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type EventTypeDataFragment = { __typename: 'EventType', id: string, code?: string | null, name: string, title: string, language: Array<string>, description?: string | null, duration: number, hasAttendeeRegistration: boolean, isOnline: boolean, location?: string | null, locationName?: string | null, accessType: EventAccessType, lat?: string | null, lng?: string | null, attendeeLimit: number, color: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, featuredImage?: { __typename: 'Media', id: string } | null, tags: Array<{ __typename: 'EventTypeTag', id: string, key: string, value: string }>, files: Array<{ __typename: 'NodeMedia', canBeDeleted: boolean, canBeUpdated: boolean, id: string, nodeId: string, documentType?: { __typename: 'MediaDocumentType', name: string, code: string, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, defaultMedia?: { __typename: 'Media', id: string, filename: string, mimeType: string, name: string } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | null, file: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } }>, notificationTemplates: Array<{ __typename: 'EventTypeNotificationTemplate', id: string, notification: { __typename: 'NotificationTemplate', id: string } }>, recurrence?: { __typename: 'Recurrence', id: string, type: RecurrenceType, rrule?: string | null } | null, reminders?: Array<{ __typename: 'ReminderItem', offset: number, template?: string | null }> | null, organizers: Array<{ __typename: 'Organizer', id: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type eventsTypesQueryVariables = Exact<{
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
}>;


export type eventsTypesQuery = { __typename: 'Query', eventsTypes: Array<{ __typename: 'EventType', id: string, code?: string | null, name: string, title: string, language: Array<string>, description?: string | null, duration: number, hasAttendeeRegistration: boolean, isOnline: boolean, location?: string | null, locationName?: string | null, accessType: EventAccessType, lat?: string | null, lng?: string | null, attendeeLimit: number, color: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, featuredImage?: { __typename: 'Media', id: string } | null, tags: Array<{ __typename: 'EventTypeTag', id: string, key: string, value: string }>, files: Array<{ __typename: 'NodeMedia', canBeDeleted: boolean, canBeUpdated: boolean, id: string, nodeId: string, documentType?: { __typename: 'MediaDocumentType', name: string, code: string, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, defaultMedia?: { __typename: 'Media', id: string, filename: string, mimeType: string, name: string } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | null, file: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } }>, notificationTemplates: Array<{ __typename: 'EventTypeNotificationTemplate', id: string, notification: { __typename: 'NotificationTemplate', id: string } }>, recurrence?: { __typename: 'Recurrence', id: string, type: RecurrenceType, rrule?: string | null } | null, reminders?: Array<{ __typename: 'ReminderItem', offset: number, template?: string | null }> | null, organizers: Array<{ __typename: 'Organizer', id: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }> };

export type EventTypeMutationMutationVariables = Exact<{
  input: EventTypeInput;
}>;


export type EventTypeMutationMutation = { __typename: 'Mutation', mutateEventType: { __typename: 'EventType', id: string, code?: string | null, name: string, title: string, language: Array<string>, description?: string | null, duration: number, hasAttendeeRegistration: boolean, isOnline: boolean, location?: string | null, locationName?: string | null, accessType: EventAccessType, lat?: string | null, lng?: string | null, attendeeLimit: number, color: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, featuredImage?: { __typename: 'Media', id: string } | null, tags: Array<{ __typename: 'EventTypeTag', id: string, key: string, value: string }>, files: Array<{ __typename: 'NodeMedia', canBeDeleted: boolean, canBeUpdated: boolean, id: string, nodeId: string, documentType?: { __typename: 'MediaDocumentType', name: string, code: string, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, defaultMedia?: { __typename: 'Media', id: string, filename: string, mimeType: string, name: string } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | null, file: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } }>, notificationTemplates: Array<{ __typename: 'EventTypeNotificationTemplate', id: string, notification: { __typename: 'NotificationTemplate', id: string } }>, recurrence?: { __typename: 'Recurrence', id: string, type: RecurrenceType, rrule?: string | null } | null, reminders?: Array<{ __typename: 'ReminderItem', offset: number, template?: string | null }> | null, organizers: Array<{ __typename: 'Organizer', id: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type MediaListDataFragment = { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type MediaDocumentTypeDataFragment = { __typename: 'MediaDocumentType', name: string, code: string, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, defaultMedia?: { __typename: 'Media', id: string, filename: string, mimeType: string, name: string } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type MediaMutationMutationVariables = Exact<{
  input: MediaInput;
}>;


export type MediaMutationMutation = { __typename: 'Mutation', mutateMedia: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type mediaQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type mediaQuery = { __typename: 'Query', media: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type mediasQueryVariables = Exact<{
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
  node?: InputMaybe<Scalars['String']>;
}>;


export type mediasQuery = { __typename: 'Query', medias: Array<{ __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }> };

export type MutateMediaMutationVariables = Exact<{
  input: MediaInput;
}>;


export type MutateMediaMutation = { __typename: 'Mutation', mutateMedia: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type mediaDocumentTypesQueryVariables = Exact<{
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
}>;


export type mediaDocumentTypesQuery = { __typename: 'Query', mediaDocumentTypes: Array<{ __typename: 'MediaDocumentType', name: string, code: string, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, defaultMedia?: { __typename: 'Media', id: string, filename: string, mimeType: string, name: string } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }> };

export type MutateMediaDocumentTypeMutationVariables = Exact<{
  input: MediaDocumentTypeInput;
}>;


export type MutateMediaDocumentTypeMutation = { __typename: 'Mutation', mutateMediaDocumentType: { __typename: 'MediaDocumentType', name: string, code: string, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, defaultMedia?: { __typename: 'Media', id: string, filename: string, mimeType: string, name: string } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type DeleteNotGlobalMediaMutationVariables = Exact<{
  input: NodeSelectInput;
}>;


export type DeleteNotGlobalMediaMutation = { __typename: 'Mutation', deleteNotGlobalMedia?: { __typename: 'RemovedNode', id: string } | null };

export type MediaAccessUrlQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MediaAccessUrlQuery = { __typename: 'Query', mediaAccessUrl: { __typename: 'UrlResponse', url: string, expiration: number, issued: number, media: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } } };

export type NodeMediaDataFragment = { __typename: 'NodeMedia', canBeDeleted: boolean, canBeUpdated: boolean, id: string, nodeId: string, documentType?: { __typename: 'MediaDocumentType', name: string, code: string, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, defaultMedia?: { __typename: 'Media', id: string, filename: string, mimeType: string, name: string } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | null, file: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type NodeMediaAccessUrlQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NodeMediaAccessUrlQuery = { __typename: 'Query', nodeMediaAccessUrl: { __typename: 'UrlResponse', url: string, expiration: number, issued: number, media: { __typename: 'Media', filename: string, mimeType: string, name: string, description?: string | null, altText?: string | null, global: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } } };

export type NotificationTemplateDataFragment = { __typename: 'NotificationTemplate', id: string, active: boolean, content: string, default: boolean, description?: string | null, method: NotificationMethod, subject: string, title: string, type: NotificationType, code?: string | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, locales: Array<{ __typename: 'NotificationTemplateLocale', id: string, locale: Locale, subject: string, content: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type notificationTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type notificationTemplateQuery = { __typename: 'Query', notificationTemplate: { __typename: 'NotificationTemplate', id: string, active: boolean, content: string, default: boolean, description?: string | null, method: NotificationMethod, subject: string, title: string, type: NotificationType, code?: string | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, locales: Array<{ __typename: 'NotificationTemplateLocale', id: string, locale: Locale, subject: string, content: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type notificationTemplatesQueryVariables = Exact<{
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
}>;


export type notificationTemplatesQuery = { __typename: 'Query', notificationTemplates: Array<{ __typename: 'NotificationTemplate', id: string, active: boolean, content: string, default: boolean, description?: string | null, method: NotificationMethod, subject: string, title: string, type: NotificationType, code?: string | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, locales: Array<{ __typename: 'NotificationTemplateLocale', id: string, locale: Locale, subject: string, content: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }> };

export type publicNotificationTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type publicNotificationTemplatesQuery = { __typename: 'Query', publicNotificationTemplates: Array<{ __typename: 'NotificationTemplate', id: string, active: boolean, content: string, default: boolean, description?: string | null, method: NotificationMethod, subject: string, title: string, type: NotificationType, code?: string | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, locales: Array<{ __typename: 'NotificationTemplateLocale', id: string, locale: Locale, subject: string, content: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }> };

export type NotificationTemplateDefaultMutationMutationVariables = Exact<{
  input: NotificationTemplateDefaultInput;
}>;


export type NotificationTemplateDefaultMutationMutation = { __typename: 'Mutation', mutateNotificationTemplateDefault: { __typename: 'NotificationTemplateDefaultResponse', nodeId?: string | null, method: NotificationMethod, type: NotificationType } };

export type NotificationTemplateMutationMutationVariables = Exact<{
  input: NotificationTemplateInput;
}>;


export type NotificationTemplateMutationMutation = { __typename: 'Mutation', mutateNotificationTemplate: { __typename: 'NotificationTemplate', id: string, active: boolean, content: string, default: boolean, description?: string | null, method: NotificationMethod, subject: string, title: string, type: NotificationType, code?: string | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, locales: Array<{ __typename: 'NotificationTemplateLocale', id: string, locale: Locale, subject: string, content: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type OrganizationBranchDataFragment = { __typename: 'OrganizationBranch', id: string, name: string, parentId?: string | null, canBeDeleted: boolean, canBeUpdated: boolean };

export type organizationBranchesQueryVariables = Exact<{ [key: string]: never; }>;


export type organizationBranchesQuery = { __typename: 'Query', organizationBranches: Array<{ __typename: 'OrganizationBranch', id: string, name: string, parentId?: string | null, canBeDeleted: boolean, canBeUpdated: boolean }> };

export type userBranchesQueryVariables = Exact<{ [key: string]: never; }>;


export type userBranchesQuery = { __typename: 'Query', userBranches: Array<{ __typename: 'OrganizationBranch', id: string, name: string, parentId?: string | null, canBeDeleted: boolean, canBeUpdated: boolean }> };

export type OrganizationBranchMutationMutationVariables = Exact<{
  input: OrganizationBranchInput;
}>;


export type OrganizationBranchMutationMutation = { __typename: 'Mutation', mutateOrganizationBranch: { __typename: 'OrganizationBranch', id: string, name: string, parentId?: string | null, canBeDeleted: boolean, canBeUpdated: boolean } };

export type OrganizersDataFragment = { __typename: 'Organizer', name: string, surname?: string | null, email?: string | null, location?: string | null, comments?: string | null, trainer: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type getOrganizersQueryVariables = Exact<{ [key: string]: never; }>;


export type getOrganizersQuery = { __typename: 'Query', organizers: Array<{ __typename: 'Organizer', name: string, surname?: string | null, email?: string | null, location?: string | null, comments?: string | null, trainer: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }> };

export type CreateOrganizerMutationMutationVariables = Exact<{
  input: OrganizerInput;
}>;


export type CreateOrganizerMutationMutation = { __typename: 'Mutation', addOrganizer: { __typename: 'Organizer', name: string, surname?: string | null, email?: string | null, location?: string | null, comments?: string | null, trainer: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type OrganizerMutationMutationVariables = Exact<{
  input: OrganizerInput;
}>;


export type OrganizerMutationMutation = { __typename: 'Mutation', mutateOrganizer: { __typename: 'Organizer', name: string, surname?: string | null, email?: string | null, location?: string | null, comments?: string | null, trainer: boolean, id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

type OwnedApiNodeData_AclRole_Fragment = { __typename: 'AclRole', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user: { __typename: 'Profile', id: string, name: string }, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_Calendar_Fragment = { __typename: 'Calendar', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_CalendarEvent_Fragment = { __typename: 'CalendarEvent', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_CustomDomainNameDnsRecords_Fragment = { __typename: 'CustomDomainNameDnsRecords', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_CustomDomainNameRequest_Fragment = { __typename: 'CustomDomainNameRequest', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_EventCategory_Fragment = { __typename: 'EventCategory', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_EventImport_Fragment = { __typename: 'EventImport', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_EventNotificationTemplate_Fragment = { __typename: 'EventNotificationTemplate', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_EventType_Fragment = { __typename: 'EventType', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_EventTypeNotificationTemplate_Fragment = { __typename: 'EventTypeNotificationTemplate', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_Media_Fragment = { __typename: 'Media', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_MediaDocumentType_Fragment = { __typename: 'MediaDocumentType', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_NotificationTemplate_Fragment = { __typename: 'NotificationTemplate', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_Organizer_Fragment = { __typename: 'Organizer', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_Pathway_Fragment = { __typename: 'Pathway', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_PathwayNotificationTemplate_Fragment = { __typename: 'PathwayNotificationTemplate', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_Profile_Fragment = { __typename: 'Profile', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_Setting_Fragment = { __typename: 'Setting', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

type OwnedApiNodeData_UserActionLog_Fragment = { __typename: 'UserActionLog', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type OwnedApiNodeDataFragment = OwnedApiNodeData_AclRole_Fragment | OwnedApiNodeData_Calendar_Fragment | OwnedApiNodeData_CalendarEvent_Fragment | OwnedApiNodeData_CustomDomainNameDnsRecords_Fragment | OwnedApiNodeData_CustomDomainNameRequest_Fragment | OwnedApiNodeData_EventCategory_Fragment | OwnedApiNodeData_EventImport_Fragment | OwnedApiNodeData_EventNotificationTemplate_Fragment | OwnedApiNodeData_EventType_Fragment | OwnedApiNodeData_EventTypeNotificationTemplate_Fragment | OwnedApiNodeData_Media_Fragment | OwnedApiNodeData_MediaDocumentType_Fragment | OwnedApiNodeData_NotificationTemplate_Fragment | OwnedApiNodeData_Organizer_Fragment | OwnedApiNodeData_Pathway_Fragment | OwnedApiNodeData_PathwayNotificationTemplate_Fragment | OwnedApiNodeData_Profile_Fragment | OwnedApiNodeData_Setting_Fragment | OwnedApiNodeData_UserActionLog_Fragment;

export type mutateNodeBranchMutationVariables = Exact<{
  input: NodeBranchInput;
}>;


export type mutateNodeBranchMutation = { __typename: 'Mutation', mutateNodeBranch: { __typename: 'AclRole', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user: { __typename: 'Profile', id: string, name: string }, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'Calendar', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'CalendarEvent', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'CustomDomainNameDnsRecords', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'CustomDomainNameRequest', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'EventCategory', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'EventImport', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'EventNotificationTemplate', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'EventType', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'EventTypeNotificationTemplate', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'Media', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'MediaDocumentType', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'NotificationTemplate', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'Organizer', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'Pathway', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'PathwayNotificationTemplate', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'Profile', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'Setting', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | { __typename: 'UserActionLog', id: string, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type PathwayItemDataFragment = { __typename: 'PathwayItem', id: string, allChildrenIDs: Array<string>, pathway: { __typename: 'Pathway', id: string }, event: { __typename: 'CalendarEvent', id: string, title: string }, parent?: { __typename: 'PathwayItem', id: string } | null };

export type pathwayItemsQueryVariables = Exact<{
  input: NodeSelectInput;
}>;


export type pathwayItemsQuery = { __typename: 'Query', pathwayItems: Array<{ __typename: 'PathwayItem', id: string, allChildrenIDs: Array<string>, pathway: { __typename: 'Pathway', id: string }, event: { __typename: 'CalendarEvent', id: string, title: string }, parent?: { __typename: 'PathwayItem', id: string } | null }> };

export type PathwayItemMutationMutationVariables = Exact<{
  input: PathwayItemInput;
}>;


export type PathwayItemMutationMutation = { __typename: 'Mutation', mutatePathwayItem: { __typename: 'PathwayItem', id: string, allChildrenIDs: Array<string>, pathway: { __typename: 'Pathway', id: string }, event: { __typename: 'CalendarEvent', id: string, title: string }, parent?: { __typename: 'PathwayItem', id: string } | null } };

export type PathwayDataFragment = { __typename: 'Pathway', id: string, title: string, description?: string | null, accessType: EventAccessType, start: number, active: boolean, registrationRequired: boolean, location?: string | null, lat?: string | null, lng?: string | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, tags: Array<{ __typename: 'PathwayTag', id: string, key: string, value: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type pathwayQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type pathwayQuery = { __typename: 'Query', pathway: { __typename: 'Pathway', id: string, title: string, description?: string | null, accessType: EventAccessType, start: number, active: boolean, registrationRequired: boolean, location?: string | null, lat?: string | null, lng?: string | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, tags: Array<{ __typename: 'PathwayTag', id: string, key: string, value: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type pathwaysQueryVariables = Exact<{
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
}>;


export type pathwaysQuery = { __typename: 'Query', pathways: Array<{ __typename: 'Pathway', id: string, title: string, description?: string | null, accessType: EventAccessType, start: number, active: boolean, registrationRequired: boolean, location?: string | null, lat?: string | null, lng?: string | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, tags: Array<{ __typename: 'PathwayTag', id: string, key: string, value: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }> };

export type PathwayMutationMutationVariables = Exact<{
  input: PathwayInput;
}>;


export type PathwayMutationMutation = { __typename: 'Mutation', mutatePathway: { __typename: 'Pathway', id: string, title: string, description?: string | null, accessType: EventAccessType, start: number, active: boolean, registrationRequired: boolean, location?: string | null, lat?: string | null, lng?: string | null, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, tags: Array<{ __typename: 'PathwayTag', id: string, key: string, value: string }>, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type OrganizationProfileDataFragment = { __typename: 'Profile', id: string, name: string, email: string, locale: Locale, active: boolean, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, aclRoles: Array<{ __typename: 'AclRole', id: string, name: string }>, organizationBranch?: { __typename: 'OrganizationBranch', id: string, name: string, parentId?: string | null } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type organizationUsersQueryVariables = Exact<{
  branchFilter?: InputMaybe<NodeBranchFilterInput>;
}>;


export type organizationUsersQuery = { __typename: 'Query', organizationUsers: Array<{ __typename: 'Profile', id: string, name: string, email: string, locale: Locale, active: boolean, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, aclRoles: Array<{ __typename: 'AclRole', id: string, name: string }>, organizationBranch?: { __typename: 'OrganizationBranch', id: string, name: string, parentId?: string | null } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null }> };

export type CreateProfileMutationMutationVariables = Exact<{
  input: NewOrganizationUserInput;
}>;


export type CreateProfileMutationMutation = { __typename: 'Mutation', createOrganizationUser: { __typename: 'Profile', id: string, name: string, email: string, locale: Locale, active: boolean, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, aclRoles: Array<{ __typename: 'AclRole', id: string, name: string }>, organizationBranch?: { __typename: 'OrganizationBranch', id: string, name: string, parentId?: string | null } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type ProfileMutationMutationVariables = Exact<{
  input: OrganizationUserEditInput;
}>;


export type ProfileMutationMutation = { __typename: 'Mutation', mutateOrganizationUser: { __typename: 'Profile', id: string, name: string, email: string, locale: Locale, active: boolean, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, canBeDeleted: boolean, canBeUpdated: boolean, aclRoles: Array<{ __typename: 'AclRole', id: string, name: string }>, organizationBranch?: { __typename: 'OrganizationBranch', id: string, name: string, parentId?: string | null } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export type ValidateEmailMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type ValidateEmailMutation = { __typename: 'Mutation', validateEmail: { __typename: 'EmailValidationResponse', email: string, setPasswordToken?: string | null } };

export type RequestPasswordResetMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type RequestPasswordResetMutation = { __typename: 'Mutation', requestPasswordReset: boolean };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename: 'Mutation', resetPassword: { __typename: 'Profile', email: string } };

export type RecurrenceInputFragment = { __typename: 'Recurrence', type: RecurrenceType, occurrences: Array<{ __typename: 'CalendarEvent', id: string, start: number }> };

type TagData_EventTag_Fragment = { __typename: 'EventTag', id: string, key: string, value: string };

type TagData_EventTypeTag_Fragment = { __typename: 'EventTypeTag', id: string, key: string, value: string };

type TagData_PathwayTag_Fragment = { __typename: 'PathwayTag', id: string, key: string, value: string };

export type TagDataFragment = TagData_EventTag_Fragment | TagData_EventTypeTag_Fragment | TagData_PathwayTag_Fragment;

export type tagNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type tagNamesQuery = { __typename: 'Query', tagNames: Array<string> };

export type tagValuesQueryVariables = Exact<{
  tagKey: Scalars['String'];
}>;


export type tagValuesQuery = { __typename: 'Query', tagValues: Array<string> };

export type LoginMutationMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutationMutation = { __typename: 'Mutation', loginToken: { __typename: 'LoginError', error: string, errorDescription: string } | { __typename: 'LoginToken', accessToken: string, refreshToken: string, expiresIn: number } };

export type RefreshMutationMutationVariables = Exact<{
  input: RefreshInput;
}>;


export type RefreshMutationMutation = { __typename: 'Mutation', refreshToken: { __typename: 'LoginError', error: string, errorDescription: string } | { __typename: 'LoginToken', accessToken: string, refreshToken: string, expiresIn: number } };

export type RegisterMutationMutationVariables = Exact<{
  input: NewUserInput;
}>;


export type RegisterMutationMutation = { __typename: 'Mutation', createUser: { __typename: 'Profile', id: string, name: string } };

export type ProfileDataFragment = { __typename: 'Profile', id: string, name: string, role: Role, locale: Locale, username: string, isOrganization: boolean, tzname: string, canBeDeleted: boolean, canBeUpdated: boolean, email: string, active: boolean, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, organization?: { __typename: 'Profile', name: string } | null, permissions: Array<{ __typename: 'AclPermissionsRow', entity: string, c: boolean, u: boolean, d: boolean, r: boolean }>, aclRoles: Array<{ __typename: 'AclRole', id: string, name: string }>, organizationBranch?: { __typename: 'OrganizationBranch', id: string, name: string, parentId?: string | null } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null };

export type viewerQueryVariables = Exact<{ [key: string]: never; }>;


export type viewerQuery = { __typename: 'Query', viewer?: { __typename: 'Profile', id: string, name: string, role: Role, locale: Locale, username: string, isOrganization: boolean, tzname: string, canBeDeleted: boolean, canBeUpdated: boolean, email: string, active: boolean, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, organization?: { __typename: 'Profile', name: string } | null, permissions: Array<{ __typename: 'AclPermissionsRow', entity: string, c: boolean, u: boolean, d: boolean, r: boolean }>, aclRoles: Array<{ __typename: 'AclRole', id: string, name: string }>, organizationBranch?: { __typename: 'OrganizationBranch', id: string, name: string, parentId?: string | null } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } | null };

export type mutateViewerMutationVariables = Exact<{
  input: ViewerEditInput;
}>;


export type mutateViewerMutation = { __typename: 'Mutation', mutateViewer: { __typename: 'Profile', id: string, name: string, role: Role, locale: Locale, username: string, isOrganization: boolean, tzname: string, canBeDeleted: boolean, canBeUpdated: boolean, email: string, active: boolean, shareWithChildBranches: boolean, createdAt: any, updatedAt: any, organization?: { __typename: 'Profile', name: string } | null, permissions: Array<{ __typename: 'AclPermissionsRow', entity: string, c: boolean, u: boolean, d: boolean, r: boolean }>, aclRoles: Array<{ __typename: 'AclRole', id: string, name: string }>, organizationBranch?: { __typename: 'OrganizationBranch', id: string, name: string, parentId?: string | null } | null, user?: { __typename: 'Profile', id: string, name: string } | null, creator?: { __typename: 'Profile', id: string, name: string } | null, branch?: { __typename: 'OrganizationBranch', id: string, name: string } | null } };

export const OwnedApiNodeDataFragmentDoc = gql`
    fragment OwnedApiNodeData on OwnedApiNode {
  id
  user {
    id
    name
  }
  creator {
    id
    name
  }
  branch {
    id
    name
  }
  shareWithChildBranches
  createdAt
  updatedAt
  canBeDeleted
  canBeUpdated
}
    `;
export const AclRoleDataFragmentDoc = gql`
    fragment AclRoleData on AclRole {
  id
  name
  active
  acl
  ...OwnedApiNodeData
}
    ${OwnedApiNodeDataFragmentDoc}`;
export const EventAttendeeDataFragmentDoc = gql`
    fragment EventAttendeeData on EventAttendee {
  id
  profile {
    id
    name
    email
  }
  event {
    id
    title
  }
  type
  confirmed
  attended
  message
  canBeDeleted
  canBeUpdated
}
    `;
export const CalendarEventBasicDataFragmentDoc = gql`
    fragment CalendarEventBasicData on CalendarEvent {
  id
  title
  description
  start
  end
  language
  color
  allDay
  attendeeLimit
  hasAttendeeRegistration
  isOnline
  isFinished
  attendees {
    ...EventAttendeeData
  }
  location
  locationName
  lat
  lng
  accessType
  recurrenceDate
  id_type
  id_calendar
  calendar {
    id
    name
    color
  }
  organizers {
    id
    email
  }
  ...OwnedApiNodeData
}
    ${EventAttendeeDataFragmentDoc}
${OwnedApiNodeDataFragmentDoc}`;
export const EventRecurrenceDataFragmentDoc = gql`
    fragment EventRecurrenceData on Recurrence {
  id
  occurrences {
    id
    start
  }
  start
  type
}
    `;
export const TagDataFragmentDoc = gql`
    fragment TagData on NodeTag {
  id
  key
  value
}
    `;
export const MediaDocumentTypeDataFragmentDoc = gql`
    fragment MediaDocumentTypeData on MediaDocumentType {
  name
  code
  defaultMedia {
    id
    filename
    mimeType
    name
  }
  ...OwnedApiNodeData
}
    ${OwnedApiNodeDataFragmentDoc}`;
export const MediaListDataFragmentDoc = gql`
    fragment MediaListData on Media {
  filename
  mimeType
  name
  description
  altText
  global
  ...OwnedApiNodeData
}
    ${OwnedApiNodeDataFragmentDoc}`;
export const NodeMediaDataFragmentDoc = gql`
    fragment NodeMediaData on NodeMedia {
  canBeDeleted
  canBeUpdated
  id
  nodeId
  documentType {
    ...MediaDocumentTypeData
  }
  file {
    ...MediaListData
  }
}
    ${MediaDocumentTypeDataFragmentDoc}
${MediaListDataFragmentDoc}`;
export const CalendarEventDataFragmentDoc = gql`
    fragment CalendarEventData on CalendarEvent {
  ...CalendarEventBasicData
  recurrence {
    ...EventRecurrenceData
  }
  tags {
    ...TagData
  }
  files {
    ...NodeMediaData
  }
  notificationTemplates {
    id
    notification {
      id
    }
  }
  featuredImage {
    id
  }
  eventImport {
    name
    id
  }
  reminders {
    offset
    template
  }
  organizers {
    id
  }
}
    ${CalendarEventBasicDataFragmentDoc}
${EventRecurrenceDataFragmentDoc}
${TagDataFragmentDoc}
${NodeMediaDataFragmentDoc}`;
export const CalendarEventExportDataFragmentDoc = gql`
    fragment CalendarEventExportData on CalendarEvent {
  id
  title
  start
  end
  allDay
  isOnline
  location
  locationName
  language
  attendeeLimit
  attendees {
    profile {
      email
    }
    attended
  }
  branch {
    name
  }
  organizers {
    email
  }
  id_type
}
    `;
export const CalendarInputFragmentDoc = gql`
    fragment CalendarInput on Calendar {
  id
  name
  color
}
    `;
export const CalendarDataFragmentDoc = gql`
    fragment CalendarData on Calendar {
  ...CalendarInput
  ...OwnedApiNodeData
}
    ${CalendarInputFragmentDoc}
${OwnedApiNodeDataFragmentDoc}`;
export const DomainInputFragmentDoc = gql`
    fragment DomainInput on CustomDomainNameRequest {
  id
  domainName
  fromEmail
  fromEmailName
  status
  customDomainNameDnsRecords {
    id
    type
    name
    value
  }
}
    `;
export const DomainDataFragmentDoc = gql`
    fragment DomainData on CustomDomainNameRequest {
  ...DomainInput
  ...OwnedApiNodeData
}
    ${DomainInputFragmentDoc}
${OwnedApiNodeDataFragmentDoc}`;
export const EventImportDataFragmentDoc = gql`
    fragment EventImportData on EventImport {
  id
  name
  file {
    ...MediaListData
  }
  log
  state
  tzname
  dateFormat
  geolocateLocation
  ...OwnedApiNodeData
}
    ${MediaListDataFragmentDoc}
${OwnedApiNodeDataFragmentDoc}`;
export const EventTypeDataFragmentDoc = gql`
    fragment EventTypeData on EventType {
  id
  code
  name
  title
  language
  description
  featuredImage {
    id
  }
  duration
  hasAttendeeRegistration
  isOnline
  location
  locationName
  accessType
  lat
  lng
  attendeeLimit
  color
  tags {
    ...TagData
  }
  files {
    ...NodeMediaData
  }
  notificationTemplates {
    id
    notification {
      id
    }
  }
  recurrence {
    id
    type
    rrule
  }
  reminders {
    offset
    template
  }
  organizers {
    id
  }
  ...OwnedApiNodeData
}
    ${TagDataFragmentDoc}
${NodeMediaDataFragmentDoc}
${OwnedApiNodeDataFragmentDoc}`;
export const NotificationTemplateDataFragmentDoc = gql`
    fragment NotificationTemplateData on NotificationTemplate {
  ...OwnedApiNodeData
  id
  active
  content
  default
  description
  locales {
    id
    locale
    subject
    content
  }
  method
  subject
  title
  type
  code
}
    ${OwnedApiNodeDataFragmentDoc}`;
export const OrganizationBranchDataFragmentDoc = gql`
    fragment OrganizationBranchData on OrganizationBranch {
  id
  name
  parentId
  canBeDeleted
  canBeUpdated
}
    `;
export const OrganizersDataFragmentDoc = gql`
    fragment OrganizersData on Organizer {
  ...OwnedApiNodeData
  name
  surname
  email
  location
  comments
  trainer
}
    ${OwnedApiNodeDataFragmentDoc}`;
export const PathwayItemDataFragmentDoc = gql`
    fragment PathwayItemData on PathwayItem {
  id
  pathway {
    id
  }
  event {
    id
    title
  }
  parent {
    id
  }
  allChildrenIDs
}
    `;
export const PathwayDataFragmentDoc = gql`
    fragment PathwayData on Pathway {
  id
  title
  description
  accessType
  start
  active
  registrationRequired
  location
  lat
  lng
  tags {
    ...TagData
  }
  ...OwnedApiNodeData
}
    ${TagDataFragmentDoc}
${OwnedApiNodeDataFragmentDoc}`;
export const RecurrenceInputFragmentDoc = gql`
    fragment RecurrenceInput on Recurrence {
  occurrences {
    id
    start
  }
  type
}
    `;
export const OrganizationProfileDataFragmentDoc = gql`
    fragment OrganizationProfileData on Profile {
  id
  name
  email
  locale
  active
  aclRoles {
    id
    name
  }
  organizationBranch {
    id
    name
    parentId
  }
  user {
    id
    name
  }
  creator {
    id
    name
  }
  branch {
    id
    name
  }
  shareWithChildBranches
  createdAt
  updatedAt
  canBeDeleted
  canBeUpdated
}
    `;
export const ProfileDataFragmentDoc = gql`
    fragment ProfileData on Profile {
  id
  name
  role
  locale
  username
  isOrganization
  organization {
    name
  }
  ...OrganizationProfileData
  permissions {
    entity
    c
    u
    d
    r
  }
  tzname
  canBeDeleted
  canBeUpdated
}
    ${OrganizationProfileDataFragmentDoc}`;
export const aclRolesDocument = gql`
    query aclRoles($branchFilter: NodeBranchFilterInput) {
  aclRoles(branchFilter: $branchFilter) {
    ...AclRoleData
  }
}
    ${AclRoleDataFragmentDoc}`;

/**
 * __useaclRolesQuery__
 *
 * To run a query within a React component, call `useaclRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useaclRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useaclRolesQuery({
 *   variables: {
 *      branchFilter: // value for 'branchFilter'
 *   },
 * });
 */
export function useaclRolesQuery(baseOptions?: Apollo.QueryHookOptions<aclRolesQuery, aclRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<aclRolesQuery, aclRolesQueryVariables>(aclRolesDocument, options);
      }
export function useaclRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<aclRolesQuery, aclRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<aclRolesQuery, aclRolesQueryVariables>(aclRolesDocument, options);
        }
export type aclRolesQueryHookResult = ReturnType<typeof useaclRolesQuery>;
export type aclRolesLazyQueryHookResult = ReturnType<typeof useaclRolesLazyQuery>;
export type aclRolesQueryResult = Apollo.QueryResult<aclRolesQuery, aclRolesQueryVariables>;
export function refetchaclRolesQuery(variables?: aclRolesQueryVariables) {
      return { query: aclRolesDocument, variables: variables }
    }
export const AclRolesMutationDocument = gql`
    mutation AclRolesMutation($input: AclRoleInput!) {
  mutateAclRole(input: $input) {
    ...AclRoleData
  }
}
    ${AclRoleDataFragmentDoc}`;
export type AclRolesMutationMutationFn = Apollo.MutationFunction<AclRolesMutationMutation, AclRolesMutationMutationVariables>;

/**
 * __useAclRolesMutationMutation__
 *
 * To run a mutation, you first call `useAclRolesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAclRolesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aclRolesMutationMutation, { data, loading, error }] = useAclRolesMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAclRolesMutationMutation(baseOptions?: Apollo.MutationHookOptions<AclRolesMutationMutation, AclRolesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AclRolesMutationMutation, AclRolesMutationMutationVariables>(AclRolesMutationDocument, options);
      }
export type AclRolesMutationMutationHookResult = ReturnType<typeof useAclRolesMutationMutation>;
export type AclRolesMutationMutationResult = Apollo.MutationResult<AclRolesMutationMutation>;
export type AclRolesMutationMutationOptions = Apollo.BaseMutationOptions<AclRolesMutationMutation, AclRolesMutationMutationVariables>;
export const DeleteNodeMutationDocument = gql`
    mutation DeleteNodeMutation($input: NodeSelectInput!) {
  deleteNode(input: $input) {
    id
  }
}
    `;
export type DeleteNodeMutationMutationFn = Apollo.MutationFunction<DeleteNodeMutationMutation, DeleteNodeMutationMutationVariables>;

/**
 * __useDeleteNodeMutationMutation__
 *
 * To run a mutation, you first call `useDeleteNodeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNodeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNodeMutationMutation, { data, loading, error }] = useDeleteNodeMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNodeMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNodeMutationMutation, DeleteNodeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNodeMutationMutation, DeleteNodeMutationMutationVariables>(DeleteNodeMutationDocument, options);
      }
export type DeleteNodeMutationMutationHookResult = ReturnType<typeof useDeleteNodeMutationMutation>;
export type DeleteNodeMutationMutationResult = Apollo.MutationResult<DeleteNodeMutationMutation>;
export type DeleteNodeMutationMutationOptions = Apollo.BaseMutationOptions<DeleteNodeMutationMutation, DeleteNodeMutationMutationVariables>;
export const DeleteNodeOrganizationUsersMutationDocument = gql`
    mutation DeleteNodeOrganizationUsersMutation($input: NodeSelectInput!) {
  deleteNodeOrganizationUsers(input: $input) {
    id
  }
}
    `;
export type DeleteNodeOrganizationUsersMutationMutationFn = Apollo.MutationFunction<DeleteNodeOrganizationUsersMutationMutation, DeleteNodeOrganizationUsersMutationMutationVariables>;

/**
 * __useDeleteNodeOrganizationUsersMutationMutation__
 *
 * To run a mutation, you first call `useDeleteNodeOrganizationUsersMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNodeOrganizationUsersMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNodeOrganizationUsersMutationMutation, { data, loading, error }] = useDeleteNodeOrganizationUsersMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNodeOrganizationUsersMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNodeOrganizationUsersMutationMutation, DeleteNodeOrganizationUsersMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNodeOrganizationUsersMutationMutation, DeleteNodeOrganizationUsersMutationMutationVariables>(DeleteNodeOrganizationUsersMutationDocument, options);
      }
export type DeleteNodeOrganizationUsersMutationMutationHookResult = ReturnType<typeof useDeleteNodeOrganizationUsersMutationMutation>;
export type DeleteNodeOrganizationUsersMutationMutationResult = Apollo.MutationResult<DeleteNodeOrganizationUsersMutationMutation>;
export type DeleteNodeOrganizationUsersMutationMutationOptions = Apollo.BaseMutationOptions<DeleteNodeOrganizationUsersMutationMutation, DeleteNodeOrganizationUsersMutationMutationVariables>;
export const GetNodePermissionsDocument = gql`
    query GetNodePermissions($input: NodeSelectInput!) {
  node(input: $input) {
    id
    canBeDeleted
    canBeUpdated
  }
}
    `;

/**
 * __useGetNodePermissionsQuery__
 *
 * To run a query within a React component, call `useGetNodePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodePermissionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNodePermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetNodePermissionsQuery, GetNodePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNodePermissionsQuery, GetNodePermissionsQueryVariables>(GetNodePermissionsDocument, options);
      }
export function useGetNodePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNodePermissionsQuery, GetNodePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNodePermissionsQuery, GetNodePermissionsQueryVariables>(GetNodePermissionsDocument, options);
        }
export type GetNodePermissionsQueryHookResult = ReturnType<typeof useGetNodePermissionsQuery>;
export type GetNodePermissionsLazyQueryHookResult = ReturnType<typeof useGetNodePermissionsLazyQuery>;
export type GetNodePermissionsQueryResult = Apollo.QueryResult<GetNodePermissionsQuery, GetNodePermissionsQueryVariables>;
export function refetchGetNodePermissionsQuery(variables: GetNodePermissionsQueryVariables) {
      return { query: GetNodePermissionsDocument, variables: variables }
    }
export const eventsDocument = gql`
    query events($fromDate: Int!, $toDate: Int!, $branchFilter: NodeBranchFilterInput) {
  events(
    input: {fromDate: $fromDate, toDate: $toDate}
    branchFilter: $branchFilter
  ) {
    ...CalendarEventBasicData
  }
}
    ${CalendarEventBasicDataFragmentDoc}`;

/**
 * __useeventsQuery__
 *
 * To run a query within a React component, call `useeventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useeventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useeventsQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      branchFilter: // value for 'branchFilter'
 *   },
 * });
 */
export function useeventsQuery(baseOptions: Apollo.QueryHookOptions<eventsQuery, eventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<eventsQuery, eventsQueryVariables>(eventsDocument, options);
      }
export function useeventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<eventsQuery, eventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<eventsQuery, eventsQueryVariables>(eventsDocument, options);
        }
export type eventsQueryHookResult = ReturnType<typeof useeventsQuery>;
export type eventsLazyQueryHookResult = ReturnType<typeof useeventsLazyQuery>;
export type eventsQueryResult = Apollo.QueryResult<eventsQuery, eventsQueryVariables>;
export function refetcheventsQuery(variables: eventsQueryVariables) {
      return { query: eventsDocument, variables: variables }
    }
export const eventsExportDocument = gql`
    query eventsExport($fromDate: Int!, $toDate: Int!, $branchFilter: NodeBranchFilterInput) {
  events(
    input: {fromDate: $fromDate, toDate: $toDate}
    branchFilter: $branchFilter
  ) {
    ...CalendarEventExportData
  }
}
    ${CalendarEventExportDataFragmentDoc}`;

/**
 * __useeventsExportQuery__
 *
 * To run a query within a React component, call `useeventsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useeventsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useeventsExportQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      branchFilter: // value for 'branchFilter'
 *   },
 * });
 */
export function useeventsExportQuery(baseOptions: Apollo.QueryHookOptions<eventsExportQuery, eventsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<eventsExportQuery, eventsExportQueryVariables>(eventsExportDocument, options);
      }
export function useeventsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<eventsExportQuery, eventsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<eventsExportQuery, eventsExportQueryVariables>(eventsExportDocument, options);
        }
export type eventsExportQueryHookResult = ReturnType<typeof useeventsExportQuery>;
export type eventsExportLazyQueryHookResult = ReturnType<typeof useeventsExportLazyQuery>;
export type eventsExportQueryResult = Apollo.QueryResult<eventsExportQuery, eventsExportQueryVariables>;
export function refetcheventsExportQuery(variables: eventsExportQueryVariables) {
      return { query: eventsExportDocument, variables: variables }
    }
export const eventDocument = gql`
    query event($id: ID!) {
  event(id: $id) {
    ...CalendarEventData
  }
}
    ${CalendarEventDataFragmentDoc}`;

/**
 * __useeventQuery__
 *
 * To run a query within a React component, call `useeventQuery` and pass it any options that fit your needs.
 * When your component renders, `useeventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useeventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useeventQuery(baseOptions: Apollo.QueryHookOptions<eventQuery, eventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<eventQuery, eventQueryVariables>(eventDocument, options);
      }
export function useeventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<eventQuery, eventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<eventQuery, eventQueryVariables>(eventDocument, options);
        }
export type eventQueryHookResult = ReturnType<typeof useeventQuery>;
export type eventLazyQueryHookResult = ReturnType<typeof useeventLazyQuery>;
export type eventQueryResult = Apollo.QueryResult<eventQuery, eventQueryVariables>;
export function refetcheventQuery(variables: eventQueryVariables) {
      return { query: eventDocument, variables: variables }
    }
export const EventMutationDocument = gql`
    mutation EventMutation($input: EventInput!) {
  mutateEvent(input: $input) {
    ...CalendarEventData
  }
}
    ${CalendarEventDataFragmentDoc}`;
export type EventMutationMutationFn = Apollo.MutationFunction<EventMutationMutation, EventMutationMutationVariables>;

/**
 * __useEventMutationMutation__
 *
 * To run a mutation, you first call `useEventMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventMutationMutation, { data, loading, error }] = useEventMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventMutationMutation(baseOptions?: Apollo.MutationHookOptions<EventMutationMutation, EventMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventMutationMutation, EventMutationMutationVariables>(EventMutationDocument, options);
      }
export type EventMutationMutationHookResult = ReturnType<typeof useEventMutationMutation>;
export type EventMutationMutationResult = Apollo.MutationResult<EventMutationMutation>;
export type EventMutationMutationOptions = Apollo.BaseMutationOptions<EventMutationMutation, EventMutationMutationVariables>;
export const resolvedEventFilesDocument = gql`
    query resolvedEventFiles($eventTypeId: ID) {
  resolvedEventFiles(eventTypeId: $eventTypeId) {
    id
    id_media
    documentTypeId
    source
  }
}
    `;

/**
 * __useresolvedEventFilesQuery__
 *
 * To run a query within a React component, call `useresolvedEventFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useresolvedEventFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useresolvedEventFilesQuery({
 *   variables: {
 *      eventTypeId: // value for 'eventTypeId'
 *   },
 * });
 */
export function useresolvedEventFilesQuery(baseOptions?: Apollo.QueryHookOptions<resolvedEventFilesQuery, resolvedEventFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<resolvedEventFilesQuery, resolvedEventFilesQueryVariables>(resolvedEventFilesDocument, options);
      }
export function useresolvedEventFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<resolvedEventFilesQuery, resolvedEventFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<resolvedEventFilesQuery, resolvedEventFilesQueryVariables>(resolvedEventFilesDocument, options);
        }
export type resolvedEventFilesQueryHookResult = ReturnType<typeof useresolvedEventFilesQuery>;
export type resolvedEventFilesLazyQueryHookResult = ReturnType<typeof useresolvedEventFilesLazyQuery>;
export type resolvedEventFilesQueryResult = Apollo.QueryResult<resolvedEventFilesQuery, resolvedEventFilesQueryVariables>;
export function refetchresolvedEventFilesQuery(variables?: resolvedEventFilesQueryVariables) {
      return { query: resolvedEventFilesDocument, variables: variables }
    }
export const calendarsDocument = gql`
    query calendars($branchFilter: NodeBranchFilterInput) {
  calendars(branchFilter: $branchFilter) {
    ...CalendarData
  }
}
    ${CalendarDataFragmentDoc}`;

/**
 * __usecalendarsQuery__
 *
 * To run a query within a React component, call `usecalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `usecalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usecalendarsQuery({
 *   variables: {
 *      branchFilter: // value for 'branchFilter'
 *   },
 * });
 */
export function usecalendarsQuery(baseOptions?: Apollo.QueryHookOptions<calendarsQuery, calendarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<calendarsQuery, calendarsQueryVariables>(calendarsDocument, options);
      }
export function usecalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<calendarsQuery, calendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<calendarsQuery, calendarsQueryVariables>(calendarsDocument, options);
        }
export type calendarsQueryHookResult = ReturnType<typeof usecalendarsQuery>;
export type calendarsLazyQueryHookResult = ReturnType<typeof usecalendarsLazyQuery>;
export type calendarsQueryResult = Apollo.QueryResult<calendarsQuery, calendarsQueryVariables>;
export function refetchcalendarsQuery(variables?: calendarsQueryVariables) {
      return { query: calendarsDocument, variables: variables }
    }
export const CalendarMutationDocument = gql`
    mutation CalendarMutation($input: CalendarInput!) {
  mutateCalendar(input: $input) {
    ...CalendarData
  }
}
    ${CalendarDataFragmentDoc}`;
export type CalendarMutationMutationFn = Apollo.MutationFunction<CalendarMutationMutation, CalendarMutationMutationVariables>;

/**
 * __useCalendarMutationMutation__
 *
 * To run a mutation, you first call `useCalendarMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarMutationMutation, { data, loading, error }] = useCalendarMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarMutationMutation(baseOptions?: Apollo.MutationHookOptions<CalendarMutationMutation, CalendarMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarMutationMutation, CalendarMutationMutationVariables>(CalendarMutationDocument, options);
      }
export type CalendarMutationMutationHookResult = ReturnType<typeof useCalendarMutationMutation>;
export type CalendarMutationMutationResult = Apollo.MutationResult<CalendarMutationMutation>;
export type CalendarMutationMutationOptions = Apollo.BaseMutationOptions<CalendarMutationMutation, CalendarMutationMutationVariables>;
export const constantsDocument = gql`
    query constants {
  constants {
    locales
    notificationMethods {
      key
      value
    }
    notificationTypes {
      key
      value
    }
    allNotificationTypes {
      key
      value
    }
  }
}
    `;

/**
 * __useconstantsQuery__
 *
 * To run a query within a React component, call `useconstantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useconstantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useconstantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useconstantsQuery(baseOptions?: Apollo.QueryHookOptions<constantsQuery, constantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<constantsQuery, constantsQueryVariables>(constantsDocument, options);
      }
export function useconstantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<constantsQuery, constantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<constantsQuery, constantsQueryVariables>(constantsDocument, options);
        }
export type constantsQueryHookResult = ReturnType<typeof useconstantsQuery>;
export type constantsLazyQueryHookResult = ReturnType<typeof useconstantsLazyQuery>;
export type constantsQueryResult = Apollo.QueryResult<constantsQuery, constantsQueryVariables>;
export function refetchconstantsQuery(variables?: constantsQueryVariables) {
      return { query: constantsDocument, variables: variables }
    }
export const aclEntitiesDocument = gql`
    query aclEntities {
  constants {
    aclRolesEntities {
      key
      value
    }
  }
}
    `;

/**
 * __useaclEntitiesQuery__
 *
 * To run a query within a React component, call `useaclEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useaclEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useaclEntitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useaclEntitiesQuery(baseOptions?: Apollo.QueryHookOptions<aclEntitiesQuery, aclEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<aclEntitiesQuery, aclEntitiesQueryVariables>(aclEntitiesDocument, options);
      }
export function useaclEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<aclEntitiesQuery, aclEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<aclEntitiesQuery, aclEntitiesQueryVariables>(aclEntitiesDocument, options);
        }
export type aclEntitiesQueryHookResult = ReturnType<typeof useaclEntitiesQuery>;
export type aclEntitiesLazyQueryHookResult = ReturnType<typeof useaclEntitiesLazyQuery>;
export type aclEntitiesQueryResult = Apollo.QueryResult<aclEntitiesQuery, aclEntitiesQueryVariables>;
export function refetchaclEntitiesQuery(variables?: aclEntitiesQueryVariables) {
      return { query: aclEntitiesDocument, variables: variables }
    }
export const getDomainDocument = gql`
    query getDomain {
  getCustomDomainNameRequest {
    ...DomainData
  }
}
    ${DomainDataFragmentDoc}`;

/**
 * __usegetDomainQuery__
 *
 * To run a query within a React component, call `usegetDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `usegetDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usegetDomainQuery({
 *   variables: {
 *   },
 * });
 */
export function usegetDomainQuery(baseOptions?: Apollo.QueryHookOptions<getDomainQuery, getDomainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<getDomainQuery, getDomainQueryVariables>(getDomainDocument, options);
      }
export function usegetDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<getDomainQuery, getDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<getDomainQuery, getDomainQueryVariables>(getDomainDocument, options);
        }
export type getDomainQueryHookResult = ReturnType<typeof usegetDomainQuery>;
export type getDomainLazyQueryHookResult = ReturnType<typeof usegetDomainLazyQuery>;
export type getDomainQueryResult = Apollo.QueryResult<getDomainQuery, getDomainQueryVariables>;
export function refetchgetDomainQuery(variables?: getDomainQueryVariables) {
      return { query: getDomainDocument, variables: variables }
    }
export const DomainEditDocument = gql`
    mutation DomainEdit($input: CustomDomainNameRequestInput!) {
  mutateCustomDomainNameRequest(input: $input) {
    ...DomainData
  }
}
    ${DomainDataFragmentDoc}`;
export type DomainEditMutationFn = Apollo.MutationFunction<DomainEditMutation, DomainEditMutationVariables>;

/**
 * __useDomainEditMutation__
 *
 * To run a mutation, you first call `useDomainEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainEditMutation, { data, loading, error }] = useDomainEditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDomainEditMutation(baseOptions?: Apollo.MutationHookOptions<DomainEditMutation, DomainEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainEditMutation, DomainEditMutationVariables>(DomainEditDocument, options);
      }
export type DomainEditMutationHookResult = ReturnType<typeof useDomainEditMutation>;
export type DomainEditMutationResult = Apollo.MutationResult<DomainEditMutation>;
export type DomainEditMutationOptions = Apollo.BaseMutationOptions<DomainEditMutation, DomainEditMutationVariables>;
export const DomainCancelDocument = gql`
    mutation DomainCancel($input: NodeSelectInput!) {
  mutateCancelCustomDomainNameRequest(input: $input) {
    ...DomainData
  }
}
    ${DomainDataFragmentDoc}`;
export type DomainCancelMutationFn = Apollo.MutationFunction<DomainCancelMutation, DomainCancelMutationVariables>;

/**
 * __useDomainCancelMutation__
 *
 * To run a mutation, you first call `useDomainCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainCancelMutation, { data, loading, error }] = useDomainCancelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDomainCancelMutation(baseOptions?: Apollo.MutationHookOptions<DomainCancelMutation, DomainCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainCancelMutation, DomainCancelMutationVariables>(DomainCancelDocument, options);
      }
export type DomainCancelMutationHookResult = ReturnType<typeof useDomainCancelMutation>;
export type DomainCancelMutationResult = Apollo.MutationResult<DomainCancelMutation>;
export type DomainCancelMutationOptions = Apollo.BaseMutationOptions<DomainCancelMutation, DomainCancelMutationVariables>;
export const DomainInProgressDocument = gql`
    mutation DomainInProgress($input: NodeSelectInput!) {
  mutateInProgressCustomDomainNameRequest(input: $input) {
    ...DomainData
  }
}
    ${DomainDataFragmentDoc}`;
export type DomainInProgressMutationFn = Apollo.MutationFunction<DomainInProgressMutation, DomainInProgressMutationVariables>;

/**
 * __useDomainInProgressMutation__
 *
 * To run a mutation, you first call `useDomainInProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainInProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainInProgressMutation, { data, loading, error }] = useDomainInProgressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDomainInProgressMutation(baseOptions?: Apollo.MutationHookOptions<DomainInProgressMutation, DomainInProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainInProgressMutation, DomainInProgressMutationVariables>(DomainInProgressDocument, options);
      }
export type DomainInProgressMutationHookResult = ReturnType<typeof useDomainInProgressMutation>;
export type DomainInProgressMutationResult = Apollo.MutationResult<DomainInProgressMutation>;
export type DomainInProgressMutationOptions = Apollo.BaseMutationOptions<DomainInProgressMutation, DomainInProgressMutationVariables>;
export const AttendanceMutationDocument = gql`
    mutation AttendanceMutation($input: EventAttendeeAttendanceInput!) {
  mutateEventAttendeeAttendance(input: $input) {
    ...EventAttendeeData
  }
}
    ${EventAttendeeDataFragmentDoc}`;
export type AttendanceMutationMutationFn = Apollo.MutationFunction<AttendanceMutationMutation, AttendanceMutationMutationVariables>;

/**
 * __useAttendanceMutationMutation__
 *
 * To run a mutation, you first call `useAttendanceMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttendanceMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attendanceMutationMutation, { data, loading, error }] = useAttendanceMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttendanceMutationMutation(baseOptions?: Apollo.MutationHookOptions<AttendanceMutationMutation, AttendanceMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttendanceMutationMutation, AttendanceMutationMutationVariables>(AttendanceMutationDocument, options);
      }
export type AttendanceMutationMutationHookResult = ReturnType<typeof useAttendanceMutationMutation>;
export type AttendanceMutationMutationResult = Apollo.MutationResult<AttendanceMutationMutation>;
export type AttendanceMutationMutationOptions = Apollo.BaseMutationOptions<AttendanceMutationMutation, AttendanceMutationMutationVariables>;
export const AttendeeMutationDocument = gql`
    mutation AttendeeMutation($input: EventAttendeeInput!) {
  mutateEventAttendee(input: $input) {
    ...EventAttendeeData
  }
}
    ${EventAttendeeDataFragmentDoc}`;
export type AttendeeMutationMutationFn = Apollo.MutationFunction<AttendeeMutationMutation, AttendeeMutationMutationVariables>;

/**
 * __useAttendeeMutationMutation__
 *
 * To run a mutation, you first call `useAttendeeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttendeeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attendeeMutationMutation, { data, loading, error }] = useAttendeeMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttendeeMutationMutation(baseOptions?: Apollo.MutationHookOptions<AttendeeMutationMutation, AttendeeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttendeeMutationMutation, AttendeeMutationMutationVariables>(AttendeeMutationDocument, options);
      }
export type AttendeeMutationMutationHookResult = ReturnType<typeof useAttendeeMutationMutation>;
export type AttendeeMutationMutationResult = Apollo.MutationResult<AttendeeMutationMutation>;
export type AttendeeMutationMutationOptions = Apollo.BaseMutationOptions<AttendeeMutationMutation, AttendeeMutationMutationVariables>;
export const attendeesDocument = gql`
    query attendees($eventId: String!) {
  eventAttendees(id: $eventId) {
    ...EventAttendeeData
  }
}
    ${EventAttendeeDataFragmentDoc}`;

/**
 * __useattendeesQuery__
 *
 * To run a query within a React component, call `useattendeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useattendeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useattendeesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useattendeesQuery(baseOptions: Apollo.QueryHookOptions<attendeesQuery, attendeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<attendeesQuery, attendeesQueryVariables>(attendeesDocument, options);
      }
export function useattendeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<attendeesQuery, attendeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<attendeesQuery, attendeesQueryVariables>(attendeesDocument, options);
        }
export type attendeesQueryHookResult = ReturnType<typeof useattendeesQuery>;
export type attendeesLazyQueryHookResult = ReturnType<typeof useattendeesLazyQuery>;
export type attendeesQueryResult = Apollo.QueryResult<attendeesQuery, attendeesQueryVariables>;
export function refetchattendeesQuery(variables: attendeesQueryVariables) {
      return { query: attendeesDocument, variables: variables }
    }
export const DecodeAndUpdateResponseDocument = gql`
    mutation DecodeAndUpdateResponse($input: TokenInvitePatientInput!) {
  decodeAndUpdateResponse(input: $input) {
    response
  }
}
    `;
export type DecodeAndUpdateResponseMutationFn = Apollo.MutationFunction<DecodeAndUpdateResponseMutation, DecodeAndUpdateResponseMutationVariables>;

/**
 * __useDecodeAndUpdateResponseMutation__
 *
 * To run a mutation, you first call `useDecodeAndUpdateResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecodeAndUpdateResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decodeAndUpdateResponseMutation, { data, loading, error }] = useDecodeAndUpdateResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDecodeAndUpdateResponseMutation(baseOptions?: Apollo.MutationHookOptions<DecodeAndUpdateResponseMutation, DecodeAndUpdateResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DecodeAndUpdateResponseMutation, DecodeAndUpdateResponseMutationVariables>(DecodeAndUpdateResponseDocument, options);
      }
export type DecodeAndUpdateResponseMutationHookResult = ReturnType<typeof useDecodeAndUpdateResponseMutation>;
export type DecodeAndUpdateResponseMutationResult = Apollo.MutationResult<DecodeAndUpdateResponseMutation>;
export type DecodeAndUpdateResponseMutationOptions = Apollo.BaseMutationOptions<DecodeAndUpdateResponseMutation, DecodeAndUpdateResponseMutationVariables>;
export const DecodeAndFindLocaleDocument = gql`
    mutation DecodeAndFindLocale($input: TokenInvitePatientInput!) {
  decodeAndFindLocale(input: $input) {
    response
  }
}
    `;
export type DecodeAndFindLocaleMutationFn = Apollo.MutationFunction<DecodeAndFindLocaleMutation, DecodeAndFindLocaleMutationVariables>;

/**
 * __useDecodeAndFindLocaleMutation__
 *
 * To run a mutation, you first call `useDecodeAndFindLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecodeAndFindLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decodeAndFindLocaleMutation, { data, loading, error }] = useDecodeAndFindLocaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDecodeAndFindLocaleMutation(baseOptions?: Apollo.MutationHookOptions<DecodeAndFindLocaleMutation, DecodeAndFindLocaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DecodeAndFindLocaleMutation, DecodeAndFindLocaleMutationVariables>(DecodeAndFindLocaleDocument, options);
      }
export type DecodeAndFindLocaleMutationHookResult = ReturnType<typeof useDecodeAndFindLocaleMutation>;
export type DecodeAndFindLocaleMutationResult = Apollo.MutationResult<DecodeAndFindLocaleMutation>;
export type DecodeAndFindLocaleMutationOptions = Apollo.BaseMutationOptions<DecodeAndFindLocaleMutation, DecodeAndFindLocaleMutationVariables>;
export const eventImportsDocument = gql`
    query eventImports($branchFilter: NodeBranchFilterInput) {
  eventImports(branchFilter: $branchFilter) {
    ...EventImportData
  }
}
    ${EventImportDataFragmentDoc}`;

/**
 * __useeventImportsQuery__
 *
 * To run a query within a React component, call `useeventImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useeventImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useeventImportsQuery({
 *   variables: {
 *      branchFilter: // value for 'branchFilter'
 *   },
 * });
 */
export function useeventImportsQuery(baseOptions?: Apollo.QueryHookOptions<eventImportsQuery, eventImportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<eventImportsQuery, eventImportsQueryVariables>(eventImportsDocument, options);
      }
export function useeventImportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<eventImportsQuery, eventImportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<eventImportsQuery, eventImportsQueryVariables>(eventImportsDocument, options);
        }
export type eventImportsQueryHookResult = ReturnType<typeof useeventImportsQuery>;
export type eventImportsLazyQueryHookResult = ReturnType<typeof useeventImportsLazyQuery>;
export type eventImportsQueryResult = Apollo.QueryResult<eventImportsQuery, eventImportsQueryVariables>;
export function refetcheventImportsQuery(variables?: eventImportsQueryVariables) {
      return { query: eventImportsDocument, variables: variables }
    }
export const EventImportMutationDocument = gql`
    mutation EventImportMutation($input: EventImportInput!) {
  mutateEventImport(input: $input) {
    ...EventImportData
  }
}
    ${EventImportDataFragmentDoc}`;
export type EventImportMutationMutationFn = Apollo.MutationFunction<EventImportMutationMutation, EventImportMutationMutationVariables>;

/**
 * __useEventImportMutationMutation__
 *
 * To run a mutation, you first call `useEventImportMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventImportMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventImportMutationMutation, { data, loading, error }] = useEventImportMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventImportMutationMutation(baseOptions?: Apollo.MutationHookOptions<EventImportMutationMutation, EventImportMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventImportMutationMutation, EventImportMutationMutationVariables>(EventImportMutationDocument, options);
      }
export type EventImportMutationMutationHookResult = ReturnType<typeof useEventImportMutationMutation>;
export type EventImportMutationMutationResult = Apollo.MutationResult<EventImportMutationMutation>;
export type EventImportMutationMutationOptions = Apollo.BaseMutationOptions<EventImportMutationMutation, EventImportMutationMutationVariables>;
export const DoEventImportMutationDocument = gql`
    mutation DoEventImportMutation($id: ID!) {
  importEvents(eventImportId: $id) {
    ...EventImportData
  }
}
    ${EventImportDataFragmentDoc}`;
export type DoEventImportMutationMutationFn = Apollo.MutationFunction<DoEventImportMutationMutation, DoEventImportMutationMutationVariables>;

/**
 * __useDoEventImportMutationMutation__
 *
 * To run a mutation, you first call `useDoEventImportMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoEventImportMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doEventImportMutationMutation, { data, loading, error }] = useDoEventImportMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoEventImportMutationMutation(baseOptions?: Apollo.MutationHookOptions<DoEventImportMutationMutation, DoEventImportMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoEventImportMutationMutation, DoEventImportMutationMutationVariables>(DoEventImportMutationDocument, options);
      }
export type DoEventImportMutationMutationHookResult = ReturnType<typeof useDoEventImportMutationMutation>;
export type DoEventImportMutationMutationResult = Apollo.MutationResult<DoEventImportMutationMutation>;
export type DoEventImportMutationMutationOptions = Apollo.BaseMutationOptions<DoEventImportMutationMutation, DoEventImportMutationMutationVariables>;
export const eventImportDocument = gql`
    query eventImport($id: ID!) {
  eventImport(id: $id) {
    ...EventImportData
  }
}
    ${EventImportDataFragmentDoc}`;

/**
 * __useeventImportQuery__
 *
 * To run a query within a React component, call `useeventImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useeventImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useeventImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useeventImportQuery(baseOptions: Apollo.QueryHookOptions<eventImportQuery, eventImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<eventImportQuery, eventImportQueryVariables>(eventImportDocument, options);
      }
export function useeventImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<eventImportQuery, eventImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<eventImportQuery, eventImportQueryVariables>(eventImportDocument, options);
        }
export type eventImportQueryHookResult = ReturnType<typeof useeventImportQuery>;
export type eventImportLazyQueryHookResult = ReturnType<typeof useeventImportLazyQuery>;
export type eventImportQueryResult = Apollo.QueryResult<eventImportQuery, eventImportQueryVariables>;
export function refetcheventImportQuery(variables: eventImportQueryVariables) {
      return { query: eventImportDocument, variables: variables }
    }
export const eventsTypesDocument = gql`
    query eventsTypes($branchFilter: NodeBranchFilterInput) {
  eventsTypes(branchFilter: $branchFilter) {
    ...EventTypeData
  }
}
    ${EventTypeDataFragmentDoc}`;

/**
 * __useeventsTypesQuery__
 *
 * To run a query within a React component, call `useeventsTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useeventsTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useeventsTypesQuery({
 *   variables: {
 *      branchFilter: // value for 'branchFilter'
 *   },
 * });
 */
export function useeventsTypesQuery(baseOptions?: Apollo.QueryHookOptions<eventsTypesQuery, eventsTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<eventsTypesQuery, eventsTypesQueryVariables>(eventsTypesDocument, options);
      }
export function useeventsTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<eventsTypesQuery, eventsTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<eventsTypesQuery, eventsTypesQueryVariables>(eventsTypesDocument, options);
        }
export type eventsTypesQueryHookResult = ReturnType<typeof useeventsTypesQuery>;
export type eventsTypesLazyQueryHookResult = ReturnType<typeof useeventsTypesLazyQuery>;
export type eventsTypesQueryResult = Apollo.QueryResult<eventsTypesQuery, eventsTypesQueryVariables>;
export function refetcheventsTypesQuery(variables?: eventsTypesQueryVariables) {
      return { query: eventsTypesDocument, variables: variables }
    }
export const EventTypeMutationDocument = gql`
    mutation EventTypeMutation($input: EventTypeInput!) {
  mutateEventType(input: $input) {
    ...EventTypeData
  }
}
    ${EventTypeDataFragmentDoc}`;
export type EventTypeMutationMutationFn = Apollo.MutationFunction<EventTypeMutationMutation, EventTypeMutationMutationVariables>;

/**
 * __useEventTypeMutationMutation__
 *
 * To run a mutation, you first call `useEventTypeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventTypeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventTypeMutationMutation, { data, loading, error }] = useEventTypeMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventTypeMutationMutation(baseOptions?: Apollo.MutationHookOptions<EventTypeMutationMutation, EventTypeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventTypeMutationMutation, EventTypeMutationMutationVariables>(EventTypeMutationDocument, options);
      }
export type EventTypeMutationMutationHookResult = ReturnType<typeof useEventTypeMutationMutation>;
export type EventTypeMutationMutationResult = Apollo.MutationResult<EventTypeMutationMutation>;
export type EventTypeMutationMutationOptions = Apollo.BaseMutationOptions<EventTypeMutationMutation, EventTypeMutationMutationVariables>;
export const MediaMutationDocument = gql`
    mutation MediaMutation($input: MediaInput!) {
  mutateMedia(input: $input) {
    ...MediaListData
  }
}
    ${MediaListDataFragmentDoc}`;
export type MediaMutationMutationFn = Apollo.MutationFunction<MediaMutationMutation, MediaMutationMutationVariables>;

/**
 * __useMediaMutationMutation__
 *
 * To run a mutation, you first call `useMediaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaMutationMutation, { data, loading, error }] = useMediaMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaMutationMutation(baseOptions?: Apollo.MutationHookOptions<MediaMutationMutation, MediaMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaMutationMutation, MediaMutationMutationVariables>(MediaMutationDocument, options);
      }
export type MediaMutationMutationHookResult = ReturnType<typeof useMediaMutationMutation>;
export type MediaMutationMutationResult = Apollo.MutationResult<MediaMutationMutation>;
export type MediaMutationMutationOptions = Apollo.BaseMutationOptions<MediaMutationMutation, MediaMutationMutationVariables>;
export const mediaDocument = gql`
    query media($id: ID!) {
  media(id: $id) {
    ...MediaListData
  }
}
    ${MediaListDataFragmentDoc}`;

/**
 * __usemediaQuery__
 *
 * To run a query within a React component, call `usemediaQuery` and pass it any options that fit your needs.
 * When your component renders, `usemediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usemediaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usemediaQuery(baseOptions: Apollo.QueryHookOptions<mediaQuery, mediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<mediaQuery, mediaQueryVariables>(mediaDocument, options);
      }
export function usemediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<mediaQuery, mediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<mediaQuery, mediaQueryVariables>(mediaDocument, options);
        }
export type mediaQueryHookResult = ReturnType<typeof usemediaQuery>;
export type mediaLazyQueryHookResult = ReturnType<typeof usemediaLazyQuery>;
export type mediaQueryResult = Apollo.QueryResult<mediaQuery, mediaQueryVariables>;
export function refetchmediaQuery(variables: mediaQueryVariables) {
      return { query: mediaDocument, variables: variables }
    }
export const mediasDocument = gql`
    query medias($branchFilter: NodeBranchFilterInput, $node: String) {
  medias(branchFilter: $branchFilter, nodeId: $node) {
    ...MediaListData
  }
}
    ${MediaListDataFragmentDoc}`;

/**
 * __usemediasQuery__
 *
 * To run a query within a React component, call `usemediasQuery` and pass it any options that fit your needs.
 * When your component renders, `usemediasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usemediasQuery({
 *   variables: {
 *      branchFilter: // value for 'branchFilter'
 *      node: // value for 'node'
 *   },
 * });
 */
export function usemediasQuery(baseOptions?: Apollo.QueryHookOptions<mediasQuery, mediasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<mediasQuery, mediasQueryVariables>(mediasDocument, options);
      }
export function usemediasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<mediasQuery, mediasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<mediasQuery, mediasQueryVariables>(mediasDocument, options);
        }
export type mediasQueryHookResult = ReturnType<typeof usemediasQuery>;
export type mediasLazyQueryHookResult = ReturnType<typeof usemediasLazyQuery>;
export type mediasQueryResult = Apollo.QueryResult<mediasQuery, mediasQueryVariables>;
export function refetchmediasQuery(variables?: mediasQueryVariables) {
      return { query: mediasDocument, variables: variables }
    }
export const MutateMediaDocument = gql`
    mutation MutateMedia($input: MediaInput!) {
  mutateMedia(input: $input) {
    ...MediaListData
  }
}
    ${MediaListDataFragmentDoc}`;
export type MutateMediaMutationFn = Apollo.MutationFunction<MutateMediaMutation, MutateMediaMutationVariables>;

/**
 * __useMutateMediaMutation__
 *
 * To run a mutation, you first call `useMutateMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateMediaMutation, { data, loading, error }] = useMutateMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMutateMediaMutation(baseOptions?: Apollo.MutationHookOptions<MutateMediaMutation, MutateMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateMediaMutation, MutateMediaMutationVariables>(MutateMediaDocument, options);
      }
export type MutateMediaMutationHookResult = ReturnType<typeof useMutateMediaMutation>;
export type MutateMediaMutationResult = Apollo.MutationResult<MutateMediaMutation>;
export type MutateMediaMutationOptions = Apollo.BaseMutationOptions<MutateMediaMutation, MutateMediaMutationVariables>;
export const mediaDocumentTypesDocument = gql`
    query mediaDocumentTypes($branchFilter: NodeBranchFilterInput) {
  mediaDocumentTypes(branchFilter: $branchFilter) {
    ...MediaDocumentTypeData
  }
}
    ${MediaDocumentTypeDataFragmentDoc}`;

/**
 * __usemediaDocumentTypesQuery__
 *
 * To run a query within a React component, call `usemediaDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usemediaDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usemediaDocumentTypesQuery({
 *   variables: {
 *      branchFilter: // value for 'branchFilter'
 *   },
 * });
 */
export function usemediaDocumentTypesQuery(baseOptions?: Apollo.QueryHookOptions<mediaDocumentTypesQuery, mediaDocumentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<mediaDocumentTypesQuery, mediaDocumentTypesQueryVariables>(mediaDocumentTypesDocument, options);
      }
export function usemediaDocumentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<mediaDocumentTypesQuery, mediaDocumentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<mediaDocumentTypesQuery, mediaDocumentTypesQueryVariables>(mediaDocumentTypesDocument, options);
        }
export type mediaDocumentTypesQueryHookResult = ReturnType<typeof usemediaDocumentTypesQuery>;
export type mediaDocumentTypesLazyQueryHookResult = ReturnType<typeof usemediaDocumentTypesLazyQuery>;
export type mediaDocumentTypesQueryResult = Apollo.QueryResult<mediaDocumentTypesQuery, mediaDocumentTypesQueryVariables>;
export function refetchmediaDocumentTypesQuery(variables?: mediaDocumentTypesQueryVariables) {
      return { query: mediaDocumentTypesDocument, variables: variables }
    }
export const MutateMediaDocumentTypeDocument = gql`
    mutation MutateMediaDocumentType($input: MediaDocumentTypeInput!) {
  mutateMediaDocumentType(input: $input) {
    ...MediaDocumentTypeData
  }
}
    ${MediaDocumentTypeDataFragmentDoc}`;
export type MutateMediaDocumentTypeMutationFn = Apollo.MutationFunction<MutateMediaDocumentTypeMutation, MutateMediaDocumentTypeMutationVariables>;

/**
 * __useMutateMediaDocumentTypeMutation__
 *
 * To run a mutation, you first call `useMutateMediaDocumentTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateMediaDocumentTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateMediaDocumentTypeMutation, { data, loading, error }] = useMutateMediaDocumentTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMutateMediaDocumentTypeMutation(baseOptions?: Apollo.MutationHookOptions<MutateMediaDocumentTypeMutation, MutateMediaDocumentTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateMediaDocumentTypeMutation, MutateMediaDocumentTypeMutationVariables>(MutateMediaDocumentTypeDocument, options);
      }
export type MutateMediaDocumentTypeMutationHookResult = ReturnType<typeof useMutateMediaDocumentTypeMutation>;
export type MutateMediaDocumentTypeMutationResult = Apollo.MutationResult<MutateMediaDocumentTypeMutation>;
export type MutateMediaDocumentTypeMutationOptions = Apollo.BaseMutationOptions<MutateMediaDocumentTypeMutation, MutateMediaDocumentTypeMutationVariables>;
export const DeleteNotGlobalMediaDocument = gql`
    mutation DeleteNotGlobalMedia($input: NodeSelectInput!) {
  deleteNotGlobalMedia(input: $input) {
    id
  }
}
    `;
export type DeleteNotGlobalMediaMutationFn = Apollo.MutationFunction<DeleteNotGlobalMediaMutation, DeleteNotGlobalMediaMutationVariables>;

/**
 * __useDeleteNotGlobalMediaMutation__
 *
 * To run a mutation, you first call `useDeleteNotGlobalMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotGlobalMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotGlobalMediaMutation, { data, loading, error }] = useDeleteNotGlobalMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNotGlobalMediaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotGlobalMediaMutation, DeleteNotGlobalMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotGlobalMediaMutation, DeleteNotGlobalMediaMutationVariables>(DeleteNotGlobalMediaDocument, options);
      }
export type DeleteNotGlobalMediaMutationHookResult = ReturnType<typeof useDeleteNotGlobalMediaMutation>;
export type DeleteNotGlobalMediaMutationResult = Apollo.MutationResult<DeleteNotGlobalMediaMutation>;
export type DeleteNotGlobalMediaMutationOptions = Apollo.BaseMutationOptions<DeleteNotGlobalMediaMutation, DeleteNotGlobalMediaMutationVariables>;
export const MediaAccessUrlDocument = gql`
    query MediaAccessUrl($id: ID!) {
  mediaAccessUrl(id: $id) {
    url
    expiration
    issued
    media {
      ...MediaListData
    }
  }
}
    ${MediaListDataFragmentDoc}`;

/**
 * __useMediaAccessUrlQuery__
 *
 * To run a query within a React component, call `useMediaAccessUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAccessUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAccessUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaAccessUrlQuery(baseOptions: Apollo.QueryHookOptions<MediaAccessUrlQuery, MediaAccessUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaAccessUrlQuery, MediaAccessUrlQueryVariables>(MediaAccessUrlDocument, options);
      }
export function useMediaAccessUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaAccessUrlQuery, MediaAccessUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaAccessUrlQuery, MediaAccessUrlQueryVariables>(MediaAccessUrlDocument, options);
        }
export type MediaAccessUrlQueryHookResult = ReturnType<typeof useMediaAccessUrlQuery>;
export type MediaAccessUrlLazyQueryHookResult = ReturnType<typeof useMediaAccessUrlLazyQuery>;
export type MediaAccessUrlQueryResult = Apollo.QueryResult<MediaAccessUrlQuery, MediaAccessUrlQueryVariables>;
export function refetchMediaAccessUrlQuery(variables: MediaAccessUrlQueryVariables) {
      return { query: MediaAccessUrlDocument, variables: variables }
    }
export const NodeMediaAccessUrlDocument = gql`
    query NodeMediaAccessUrl($id: ID!) {
  nodeMediaAccessUrl(id: $id) {
    url
    expiration
    issued
    media {
      ...MediaListData
    }
  }
}
    ${MediaListDataFragmentDoc}`;

/**
 * __useNodeMediaAccessUrlQuery__
 *
 * To run a query within a React component, call `useNodeMediaAccessUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useNodeMediaAccessUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodeMediaAccessUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNodeMediaAccessUrlQuery(baseOptions: Apollo.QueryHookOptions<NodeMediaAccessUrlQuery, NodeMediaAccessUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NodeMediaAccessUrlQuery, NodeMediaAccessUrlQueryVariables>(NodeMediaAccessUrlDocument, options);
      }
export function useNodeMediaAccessUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NodeMediaAccessUrlQuery, NodeMediaAccessUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NodeMediaAccessUrlQuery, NodeMediaAccessUrlQueryVariables>(NodeMediaAccessUrlDocument, options);
        }
export type NodeMediaAccessUrlQueryHookResult = ReturnType<typeof useNodeMediaAccessUrlQuery>;
export type NodeMediaAccessUrlLazyQueryHookResult = ReturnType<typeof useNodeMediaAccessUrlLazyQuery>;
export type NodeMediaAccessUrlQueryResult = Apollo.QueryResult<NodeMediaAccessUrlQuery, NodeMediaAccessUrlQueryVariables>;
export function refetchNodeMediaAccessUrlQuery(variables: NodeMediaAccessUrlQueryVariables) {
      return { query: NodeMediaAccessUrlDocument, variables: variables }
    }
export const notificationTemplateDocument = gql`
    query notificationTemplate($id: ID!) {
  notificationTemplate(id: $id) {
    ...NotificationTemplateData
  }
}
    ${NotificationTemplateDataFragmentDoc}`;

/**
 * __usenotificationTemplateQuery__
 *
 * To run a query within a React component, call `usenotificationTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usenotificationTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usenotificationTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usenotificationTemplateQuery(baseOptions: Apollo.QueryHookOptions<notificationTemplateQuery, notificationTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<notificationTemplateQuery, notificationTemplateQueryVariables>(notificationTemplateDocument, options);
      }
export function usenotificationTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<notificationTemplateQuery, notificationTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<notificationTemplateQuery, notificationTemplateQueryVariables>(notificationTemplateDocument, options);
        }
export type notificationTemplateQueryHookResult = ReturnType<typeof usenotificationTemplateQuery>;
export type notificationTemplateLazyQueryHookResult = ReturnType<typeof usenotificationTemplateLazyQuery>;
export type notificationTemplateQueryResult = Apollo.QueryResult<notificationTemplateQuery, notificationTemplateQueryVariables>;
export function refetchnotificationTemplateQuery(variables: notificationTemplateQueryVariables) {
      return { query: notificationTemplateDocument, variables: variables }
    }
export const notificationTemplatesDocument = gql`
    query notificationTemplates($branchFilter: NodeBranchFilterInput) {
  notificationTemplates(branchFilter: $branchFilter) {
    ...NotificationTemplateData
  }
}
    ${NotificationTemplateDataFragmentDoc}`;

/**
 * __usenotificationTemplatesQuery__
 *
 * To run a query within a React component, call `usenotificationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usenotificationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usenotificationTemplatesQuery({
 *   variables: {
 *      branchFilter: // value for 'branchFilter'
 *   },
 * });
 */
export function usenotificationTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<notificationTemplatesQuery, notificationTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<notificationTemplatesQuery, notificationTemplatesQueryVariables>(notificationTemplatesDocument, options);
      }
export function usenotificationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<notificationTemplatesQuery, notificationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<notificationTemplatesQuery, notificationTemplatesQueryVariables>(notificationTemplatesDocument, options);
        }
export type notificationTemplatesQueryHookResult = ReturnType<typeof usenotificationTemplatesQuery>;
export type notificationTemplatesLazyQueryHookResult = ReturnType<typeof usenotificationTemplatesLazyQuery>;
export type notificationTemplatesQueryResult = Apollo.QueryResult<notificationTemplatesQuery, notificationTemplatesQueryVariables>;
export function refetchnotificationTemplatesQuery(variables?: notificationTemplatesQueryVariables) {
      return { query: notificationTemplatesDocument, variables: variables }
    }
export const publicNotificationTemplatesDocument = gql`
    query publicNotificationTemplates {
  publicNotificationTemplates {
    ...NotificationTemplateData
  }
}
    ${NotificationTemplateDataFragmentDoc}`;

/**
 * __usepublicNotificationTemplatesQuery__
 *
 * To run a query within a React component, call `usepublicNotificationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usepublicNotificationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usepublicNotificationTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function usepublicNotificationTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<publicNotificationTemplatesQuery, publicNotificationTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<publicNotificationTemplatesQuery, publicNotificationTemplatesQueryVariables>(publicNotificationTemplatesDocument, options);
      }
export function usepublicNotificationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<publicNotificationTemplatesQuery, publicNotificationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<publicNotificationTemplatesQuery, publicNotificationTemplatesQueryVariables>(publicNotificationTemplatesDocument, options);
        }
export type publicNotificationTemplatesQueryHookResult = ReturnType<typeof usepublicNotificationTemplatesQuery>;
export type publicNotificationTemplatesLazyQueryHookResult = ReturnType<typeof usepublicNotificationTemplatesLazyQuery>;
export type publicNotificationTemplatesQueryResult = Apollo.QueryResult<publicNotificationTemplatesQuery, publicNotificationTemplatesQueryVariables>;
export function refetchpublicNotificationTemplatesQuery(variables?: publicNotificationTemplatesQueryVariables) {
      return { query: publicNotificationTemplatesDocument, variables: variables }
    }
export const NotificationTemplateDefaultMutationDocument = gql`
    mutation NotificationTemplateDefaultMutation($input: NotificationTemplateDefaultInput!) {
  mutateNotificationTemplateDefault(input: $input) {
    nodeId
    method
    type
  }
}
    `;
export type NotificationTemplateDefaultMutationMutationFn = Apollo.MutationFunction<NotificationTemplateDefaultMutationMutation, NotificationTemplateDefaultMutationMutationVariables>;

/**
 * __useNotificationTemplateDefaultMutationMutation__
 *
 * To run a mutation, you first call `useNotificationTemplateDefaultMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationTemplateDefaultMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationTemplateDefaultMutationMutation, { data, loading, error }] = useNotificationTemplateDefaultMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificationTemplateDefaultMutationMutation(baseOptions?: Apollo.MutationHookOptions<NotificationTemplateDefaultMutationMutation, NotificationTemplateDefaultMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationTemplateDefaultMutationMutation, NotificationTemplateDefaultMutationMutationVariables>(NotificationTemplateDefaultMutationDocument, options);
      }
export type NotificationTemplateDefaultMutationMutationHookResult = ReturnType<typeof useNotificationTemplateDefaultMutationMutation>;
export type NotificationTemplateDefaultMutationMutationResult = Apollo.MutationResult<NotificationTemplateDefaultMutationMutation>;
export type NotificationTemplateDefaultMutationMutationOptions = Apollo.BaseMutationOptions<NotificationTemplateDefaultMutationMutation, NotificationTemplateDefaultMutationMutationVariables>;
export const NotificationTemplateMutationDocument = gql`
    mutation NotificationTemplateMutation($input: NotificationTemplateInput!) {
  mutateNotificationTemplate(input: $input) {
    ...NotificationTemplateData
  }
}
    ${NotificationTemplateDataFragmentDoc}`;
export type NotificationTemplateMutationMutationFn = Apollo.MutationFunction<NotificationTemplateMutationMutation, NotificationTemplateMutationMutationVariables>;

/**
 * __useNotificationTemplateMutationMutation__
 *
 * To run a mutation, you first call `useNotificationTemplateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationTemplateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationTemplateMutationMutation, { data, loading, error }] = useNotificationTemplateMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotificationTemplateMutationMutation(baseOptions?: Apollo.MutationHookOptions<NotificationTemplateMutationMutation, NotificationTemplateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationTemplateMutationMutation, NotificationTemplateMutationMutationVariables>(NotificationTemplateMutationDocument, options);
      }
export type NotificationTemplateMutationMutationHookResult = ReturnType<typeof useNotificationTemplateMutationMutation>;
export type NotificationTemplateMutationMutationResult = Apollo.MutationResult<NotificationTemplateMutationMutation>;
export type NotificationTemplateMutationMutationOptions = Apollo.BaseMutationOptions<NotificationTemplateMutationMutation, NotificationTemplateMutationMutationVariables>;
export const organizationBranchesDocument = gql`
    query organizationBranches {
  organizationBranches {
    ...OrganizationBranchData
  }
}
    ${OrganizationBranchDataFragmentDoc}`;

/**
 * __useorganizationBranchesQuery__
 *
 * To run a query within a React component, call `useorganizationBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useorganizationBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useorganizationBranchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useorganizationBranchesQuery(baseOptions?: Apollo.QueryHookOptions<organizationBranchesQuery, organizationBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<organizationBranchesQuery, organizationBranchesQueryVariables>(organizationBranchesDocument, options);
      }
export function useorganizationBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<organizationBranchesQuery, organizationBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<organizationBranchesQuery, organizationBranchesQueryVariables>(organizationBranchesDocument, options);
        }
export type organizationBranchesQueryHookResult = ReturnType<typeof useorganizationBranchesQuery>;
export type organizationBranchesLazyQueryHookResult = ReturnType<typeof useorganizationBranchesLazyQuery>;
export type organizationBranchesQueryResult = Apollo.QueryResult<organizationBranchesQuery, organizationBranchesQueryVariables>;
export function refetchorganizationBranchesQuery(variables?: organizationBranchesQueryVariables) {
      return { query: organizationBranchesDocument, variables: variables }
    }
export const userBranchesDocument = gql`
    query userBranches {
  userBranches {
    ...OrganizationBranchData
  }
}
    ${OrganizationBranchDataFragmentDoc}`;

/**
 * __useuserBranchesQuery__
 *
 * To run a query within a React component, call `useuserBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useuserBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useuserBranchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useuserBranchesQuery(baseOptions?: Apollo.QueryHookOptions<userBranchesQuery, userBranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<userBranchesQuery, userBranchesQueryVariables>(userBranchesDocument, options);
      }
export function useuserBranchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<userBranchesQuery, userBranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<userBranchesQuery, userBranchesQueryVariables>(userBranchesDocument, options);
        }
export type userBranchesQueryHookResult = ReturnType<typeof useuserBranchesQuery>;
export type userBranchesLazyQueryHookResult = ReturnType<typeof useuserBranchesLazyQuery>;
export type userBranchesQueryResult = Apollo.QueryResult<userBranchesQuery, userBranchesQueryVariables>;
export function refetchuserBranchesQuery(variables?: userBranchesQueryVariables) {
      return { query: userBranchesDocument, variables: variables }
    }
export const OrganizationBranchMutationDocument = gql`
    mutation OrganizationBranchMutation($input: OrganizationBranchInput!) {
  mutateOrganizationBranch(input: $input) {
    ...OrganizationBranchData
  }
}
    ${OrganizationBranchDataFragmentDoc}`;
export type OrganizationBranchMutationMutationFn = Apollo.MutationFunction<OrganizationBranchMutationMutation, OrganizationBranchMutationMutationVariables>;

/**
 * __useOrganizationBranchMutationMutation__
 *
 * To run a mutation, you first call `useOrganizationBranchMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationBranchMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationBranchMutationMutation, { data, loading, error }] = useOrganizationBranchMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationBranchMutationMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationBranchMutationMutation, OrganizationBranchMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationBranchMutationMutation, OrganizationBranchMutationMutationVariables>(OrganizationBranchMutationDocument, options);
      }
export type OrganizationBranchMutationMutationHookResult = ReturnType<typeof useOrganizationBranchMutationMutation>;
export type OrganizationBranchMutationMutationResult = Apollo.MutationResult<OrganizationBranchMutationMutation>;
export type OrganizationBranchMutationMutationOptions = Apollo.BaseMutationOptions<OrganizationBranchMutationMutation, OrganizationBranchMutationMutationVariables>;
export const getOrganizersDocument = gql`
    query getOrganizers {
  organizers {
    ...OrganizersData
  }
}
    ${OrganizersDataFragmentDoc}`;

/**
 * __usegetOrganizersQuery__
 *
 * To run a query within a React component, call `usegetOrganizersQuery` and pass it any options that fit your needs.
 * When your component renders, `usegetOrganizersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usegetOrganizersQuery({
 *   variables: {
 *   },
 * });
 */
export function usegetOrganizersQuery(baseOptions?: Apollo.QueryHookOptions<getOrganizersQuery, getOrganizersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<getOrganizersQuery, getOrganizersQueryVariables>(getOrganizersDocument, options);
      }
export function usegetOrganizersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<getOrganizersQuery, getOrganizersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<getOrganizersQuery, getOrganizersQueryVariables>(getOrganizersDocument, options);
        }
export type getOrganizersQueryHookResult = ReturnType<typeof usegetOrganizersQuery>;
export type getOrganizersLazyQueryHookResult = ReturnType<typeof usegetOrganizersLazyQuery>;
export type getOrganizersQueryResult = Apollo.QueryResult<getOrganizersQuery, getOrganizersQueryVariables>;
export function refetchgetOrganizersQuery(variables?: getOrganizersQueryVariables) {
      return { query: getOrganizersDocument, variables: variables }
    }
export const CreateOrganizerMutationDocument = gql`
    mutation CreateOrganizerMutation($input: OrganizerInput!) {
  addOrganizer(input: $input) {
    ...OrganizersData
  }
}
    ${OrganizersDataFragmentDoc}`;
export type CreateOrganizerMutationMutationFn = Apollo.MutationFunction<CreateOrganizerMutationMutation, CreateOrganizerMutationMutationVariables>;

/**
 * __useCreateOrganizerMutationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizerMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizerMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizerMutationMutation, { data, loading, error }] = useCreateOrganizerMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizerMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizerMutationMutation, CreateOrganizerMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizerMutationMutation, CreateOrganizerMutationMutationVariables>(CreateOrganizerMutationDocument, options);
      }
export type CreateOrganizerMutationMutationHookResult = ReturnType<typeof useCreateOrganizerMutationMutation>;
export type CreateOrganizerMutationMutationResult = Apollo.MutationResult<CreateOrganizerMutationMutation>;
export type CreateOrganizerMutationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizerMutationMutation, CreateOrganizerMutationMutationVariables>;
export const OrganizerMutationDocument = gql`
    mutation OrganizerMutation($input: OrganizerInput!) {
  mutateOrganizer(input: $input) {
    ...OrganizersData
  }
}
    ${OrganizersDataFragmentDoc}`;
export type OrganizerMutationMutationFn = Apollo.MutationFunction<OrganizerMutationMutation, OrganizerMutationMutationVariables>;

/**
 * __useOrganizerMutationMutation__
 *
 * To run a mutation, you first call `useOrganizerMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizerMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizerMutationMutation, { data, loading, error }] = useOrganizerMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizerMutationMutation(baseOptions?: Apollo.MutationHookOptions<OrganizerMutationMutation, OrganizerMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizerMutationMutation, OrganizerMutationMutationVariables>(OrganizerMutationDocument, options);
      }
export type OrganizerMutationMutationHookResult = ReturnType<typeof useOrganizerMutationMutation>;
export type OrganizerMutationMutationResult = Apollo.MutationResult<OrganizerMutationMutation>;
export type OrganizerMutationMutationOptions = Apollo.BaseMutationOptions<OrganizerMutationMutation, OrganizerMutationMutationVariables>;
export const mutateNodeBranchDocument = gql`
    mutation mutateNodeBranch($input: NodeBranchInput!) {
  mutateNodeBranch(input: $input) {
    ...OwnedApiNodeData
  }
}
    ${OwnedApiNodeDataFragmentDoc}`;
export type mutateNodeBranchMutationFn = Apollo.MutationFunction<mutateNodeBranchMutation, mutateNodeBranchMutationVariables>;

/**
 * __usemutateNodeBranchMutation__
 *
 * To run a mutation, you first call `usemutateNodeBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usemutateNodeBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateNodeBranchMutation, { data, loading, error }] = usemutateNodeBranchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usemutateNodeBranchMutation(baseOptions?: Apollo.MutationHookOptions<mutateNodeBranchMutation, mutateNodeBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<mutateNodeBranchMutation, mutateNodeBranchMutationVariables>(mutateNodeBranchDocument, options);
      }
export type mutateNodeBranchMutationHookResult = ReturnType<typeof usemutateNodeBranchMutation>;
export type mutateNodeBranchMutationResult = Apollo.MutationResult<mutateNodeBranchMutation>;
export type mutateNodeBranchMutationOptions = Apollo.BaseMutationOptions<mutateNodeBranchMutation, mutateNodeBranchMutationVariables>;
export const pathwayItemsDocument = gql`
    query pathwayItems($input: NodeSelectInput!) {
  pathwayItems(input: $input) {
    ...PathwayItemData
  }
}
    ${PathwayItemDataFragmentDoc}`;

/**
 * __usepathwayItemsQuery__
 *
 * To run a query within a React component, call `usepathwayItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usepathwayItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usepathwayItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usepathwayItemsQuery(baseOptions: Apollo.QueryHookOptions<pathwayItemsQuery, pathwayItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<pathwayItemsQuery, pathwayItemsQueryVariables>(pathwayItemsDocument, options);
      }
export function usepathwayItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<pathwayItemsQuery, pathwayItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<pathwayItemsQuery, pathwayItemsQueryVariables>(pathwayItemsDocument, options);
        }
export type pathwayItemsQueryHookResult = ReturnType<typeof usepathwayItemsQuery>;
export type pathwayItemsLazyQueryHookResult = ReturnType<typeof usepathwayItemsLazyQuery>;
export type pathwayItemsQueryResult = Apollo.QueryResult<pathwayItemsQuery, pathwayItemsQueryVariables>;
export function refetchpathwayItemsQuery(variables: pathwayItemsQueryVariables) {
      return { query: pathwayItemsDocument, variables: variables }
    }
export const PathwayItemMutationDocument = gql`
    mutation PathwayItemMutation($input: PathwayItemInput!) {
  mutatePathwayItem(input: $input) {
    ...PathwayItemData
  }
}
    ${PathwayItemDataFragmentDoc}`;
export type PathwayItemMutationMutationFn = Apollo.MutationFunction<PathwayItemMutationMutation, PathwayItemMutationMutationVariables>;

/**
 * __usePathwayItemMutationMutation__
 *
 * To run a mutation, you first call `usePathwayItemMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathwayItemMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathwayItemMutationMutation, { data, loading, error }] = usePathwayItemMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePathwayItemMutationMutation(baseOptions?: Apollo.MutationHookOptions<PathwayItemMutationMutation, PathwayItemMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PathwayItemMutationMutation, PathwayItemMutationMutationVariables>(PathwayItemMutationDocument, options);
      }
export type PathwayItemMutationMutationHookResult = ReturnType<typeof usePathwayItemMutationMutation>;
export type PathwayItemMutationMutationResult = Apollo.MutationResult<PathwayItemMutationMutation>;
export type PathwayItemMutationMutationOptions = Apollo.BaseMutationOptions<PathwayItemMutationMutation, PathwayItemMutationMutationVariables>;
export const pathwayDocument = gql`
    query pathway($id: ID!) {
  pathway(id: $id) {
    ...PathwayData
  }
}
    ${PathwayDataFragmentDoc}`;

/**
 * __usepathwayQuery__
 *
 * To run a query within a React component, call `usepathwayQuery` and pass it any options that fit your needs.
 * When your component renders, `usepathwayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usepathwayQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usepathwayQuery(baseOptions: Apollo.QueryHookOptions<pathwayQuery, pathwayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<pathwayQuery, pathwayQueryVariables>(pathwayDocument, options);
      }
export function usepathwayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<pathwayQuery, pathwayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<pathwayQuery, pathwayQueryVariables>(pathwayDocument, options);
        }
export type pathwayQueryHookResult = ReturnType<typeof usepathwayQuery>;
export type pathwayLazyQueryHookResult = ReturnType<typeof usepathwayLazyQuery>;
export type pathwayQueryResult = Apollo.QueryResult<pathwayQuery, pathwayQueryVariables>;
export function refetchpathwayQuery(variables: pathwayQueryVariables) {
      return { query: pathwayDocument, variables: variables }
    }
export const pathwaysDocument = gql`
    query pathways($branchFilter: NodeBranchFilterInput) {
  pathways(branchFilter: $branchFilter) {
    ...PathwayData
  }
}
    ${PathwayDataFragmentDoc}`;

/**
 * __usepathwaysQuery__
 *
 * To run a query within a React component, call `usepathwaysQuery` and pass it any options that fit your needs.
 * When your component renders, `usepathwaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usepathwaysQuery({
 *   variables: {
 *      branchFilter: // value for 'branchFilter'
 *   },
 * });
 */
export function usepathwaysQuery(baseOptions?: Apollo.QueryHookOptions<pathwaysQuery, pathwaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<pathwaysQuery, pathwaysQueryVariables>(pathwaysDocument, options);
      }
export function usepathwaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<pathwaysQuery, pathwaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<pathwaysQuery, pathwaysQueryVariables>(pathwaysDocument, options);
        }
export type pathwaysQueryHookResult = ReturnType<typeof usepathwaysQuery>;
export type pathwaysLazyQueryHookResult = ReturnType<typeof usepathwaysLazyQuery>;
export type pathwaysQueryResult = Apollo.QueryResult<pathwaysQuery, pathwaysQueryVariables>;
export function refetchpathwaysQuery(variables?: pathwaysQueryVariables) {
      return { query: pathwaysDocument, variables: variables }
    }
export const PathwayMutationDocument = gql`
    mutation PathwayMutation($input: PathwayInput!) {
  mutatePathway(input: $input) {
    ...PathwayData
  }
}
    ${PathwayDataFragmentDoc}`;
export type PathwayMutationMutationFn = Apollo.MutationFunction<PathwayMutationMutation, PathwayMutationMutationVariables>;

/**
 * __usePathwayMutationMutation__
 *
 * To run a mutation, you first call `usePathwayMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathwayMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathwayMutationMutation, { data, loading, error }] = usePathwayMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePathwayMutationMutation(baseOptions?: Apollo.MutationHookOptions<PathwayMutationMutation, PathwayMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PathwayMutationMutation, PathwayMutationMutationVariables>(PathwayMutationDocument, options);
      }
export type PathwayMutationMutationHookResult = ReturnType<typeof usePathwayMutationMutation>;
export type PathwayMutationMutationResult = Apollo.MutationResult<PathwayMutationMutation>;
export type PathwayMutationMutationOptions = Apollo.BaseMutationOptions<PathwayMutationMutation, PathwayMutationMutationVariables>;
export const organizationUsersDocument = gql`
    query organizationUsers($branchFilter: NodeBranchFilterInput) {
  organizationUsers(branchFilter: $branchFilter) {
    ...OrganizationProfileData
  }
}
    ${OrganizationProfileDataFragmentDoc}`;

/**
 * __useorganizationUsersQuery__
 *
 * To run a query within a React component, call `useorganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useorganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useorganizationUsersQuery({
 *   variables: {
 *      branchFilter: // value for 'branchFilter'
 *   },
 * });
 */
export function useorganizationUsersQuery(baseOptions?: Apollo.QueryHookOptions<organizationUsersQuery, organizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<organizationUsersQuery, organizationUsersQueryVariables>(organizationUsersDocument, options);
      }
export function useorganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<organizationUsersQuery, organizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<organizationUsersQuery, organizationUsersQueryVariables>(organizationUsersDocument, options);
        }
export type organizationUsersQueryHookResult = ReturnType<typeof useorganizationUsersQuery>;
export type organizationUsersLazyQueryHookResult = ReturnType<typeof useorganizationUsersLazyQuery>;
export type organizationUsersQueryResult = Apollo.QueryResult<organizationUsersQuery, organizationUsersQueryVariables>;
export function refetchorganizationUsersQuery(variables?: organizationUsersQueryVariables) {
      return { query: organizationUsersDocument, variables: variables }
    }
export const CreateProfileMutationDocument = gql`
    mutation CreateProfileMutation($input: NewOrganizationUserInput!) {
  createOrganizationUser(input: $input) {
    ...OrganizationProfileData
  }
}
    ${OrganizationProfileDataFragmentDoc}`;
export type CreateProfileMutationMutationFn = Apollo.MutationFunction<CreateProfileMutationMutation, CreateProfileMutationMutationVariables>;

/**
 * __useCreateProfileMutationMutation__
 *
 * To run a mutation, you first call `useCreateProfileMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProfileMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProfileMutationMutation, { data, loading, error }] = useCreateProfileMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProfileMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateProfileMutationMutation, CreateProfileMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProfileMutationMutation, CreateProfileMutationMutationVariables>(CreateProfileMutationDocument, options);
      }
export type CreateProfileMutationMutationHookResult = ReturnType<typeof useCreateProfileMutationMutation>;
export type CreateProfileMutationMutationResult = Apollo.MutationResult<CreateProfileMutationMutation>;
export type CreateProfileMutationMutationOptions = Apollo.BaseMutationOptions<CreateProfileMutationMutation, CreateProfileMutationMutationVariables>;
export const ProfileMutationDocument = gql`
    mutation ProfileMutation($input: OrganizationUserEditInput!) {
  mutateOrganizationUser(input: $input) {
    ...OrganizationProfileData
  }
}
    ${OrganizationProfileDataFragmentDoc}`;
export type ProfileMutationMutationFn = Apollo.MutationFunction<ProfileMutationMutation, ProfileMutationMutationVariables>;

/**
 * __useProfileMutationMutation__
 *
 * To run a mutation, you first call `useProfileMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileMutationMutation, { data, loading, error }] = useProfileMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProfileMutationMutation(baseOptions?: Apollo.MutationHookOptions<ProfileMutationMutation, ProfileMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileMutationMutation, ProfileMutationMutationVariables>(ProfileMutationDocument, options);
      }
export type ProfileMutationMutationHookResult = ReturnType<typeof useProfileMutationMutation>;
export type ProfileMutationMutationResult = Apollo.MutationResult<ProfileMutationMutation>;
export type ProfileMutationMutationOptions = Apollo.BaseMutationOptions<ProfileMutationMutation, ProfileMutationMutationVariables>;
export const ValidateEmailDocument = gql`
    mutation ValidateEmail($input: String!) {
  validateEmail(input: $input) {
    email
    setPasswordToken
  }
}
    `;
export type ValidateEmailMutationFn = Apollo.MutationFunction<ValidateEmailMutation, ValidateEmailMutationVariables>;

/**
 * __useValidateEmailMutation__
 *
 * To run a mutation, you first call `useValidateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateEmailMutation, { data, loading, error }] = useValidateEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateEmailMutation(baseOptions?: Apollo.MutationHookOptions<ValidateEmailMutation, ValidateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateEmailMutation, ValidateEmailMutationVariables>(ValidateEmailDocument, options);
      }
export type ValidateEmailMutationHookResult = ReturnType<typeof useValidateEmailMutation>;
export type ValidateEmailMutationResult = Apollo.MutationResult<ValidateEmailMutation>;
export type ValidateEmailMutationOptions = Apollo.BaseMutationOptions<ValidateEmailMutation, ValidateEmailMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($input: String!) {
  requestPasswordReset(input: $input)
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    email
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const tagNamesDocument = gql`
    query tagNames {
  tagNames
}
    `;

/**
 * __usetagNamesQuery__
 *
 * To run a query within a React component, call `usetagNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usetagNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usetagNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function usetagNamesQuery(baseOptions?: Apollo.QueryHookOptions<tagNamesQuery, tagNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<tagNamesQuery, tagNamesQueryVariables>(tagNamesDocument, options);
      }
export function usetagNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<tagNamesQuery, tagNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<tagNamesQuery, tagNamesQueryVariables>(tagNamesDocument, options);
        }
export type tagNamesQueryHookResult = ReturnType<typeof usetagNamesQuery>;
export type tagNamesLazyQueryHookResult = ReturnType<typeof usetagNamesLazyQuery>;
export type tagNamesQueryResult = Apollo.QueryResult<tagNamesQuery, tagNamesQueryVariables>;
export function refetchtagNamesQuery(variables?: tagNamesQueryVariables) {
      return { query: tagNamesDocument, variables: variables }
    }
export const tagValuesDocument = gql`
    query tagValues($tagKey: String!) {
  tagValues(tagKey: $tagKey)
}
    `;

/**
 * __usetagValuesQuery__
 *
 * To run a query within a React component, call `usetagValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `usetagValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usetagValuesQuery({
 *   variables: {
 *      tagKey: // value for 'tagKey'
 *   },
 * });
 */
export function usetagValuesQuery(baseOptions: Apollo.QueryHookOptions<tagValuesQuery, tagValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<tagValuesQuery, tagValuesQueryVariables>(tagValuesDocument, options);
      }
export function usetagValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<tagValuesQuery, tagValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<tagValuesQuery, tagValuesQueryVariables>(tagValuesDocument, options);
        }
export type tagValuesQueryHookResult = ReturnType<typeof usetagValuesQuery>;
export type tagValuesLazyQueryHookResult = ReturnType<typeof usetagValuesLazyQuery>;
export type tagValuesQueryResult = Apollo.QueryResult<tagValuesQuery, tagValuesQueryVariables>;
export function refetchtagValuesQuery(variables: tagValuesQueryVariables) {
      return { query: tagValuesDocument, variables: variables }
    }
export const LoginMutationDocument = gql`
    mutation LoginMutation($input: LoginInput!) {
  loginToken(input: $input) {
    ... on LoginToken {
      accessToken
      refreshToken
      expiresIn
    }
    ... on LoginError {
      error
      errorDescription
    }
  }
}
    `;
export type LoginMutationMutationFn = Apollo.MutationFunction<LoginMutationMutation, LoginMutationMutationVariables>;

/**
 * __useLoginMutationMutation__
 *
 * To run a mutation, you first call `useLoginMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutationMutation, { data, loading, error }] = useLoginMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutationMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutationMutation, LoginMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutationMutation, LoginMutationMutationVariables>(LoginMutationDocument, options);
      }
export type LoginMutationMutationHookResult = ReturnType<typeof useLoginMutationMutation>;
export type LoginMutationMutationResult = Apollo.MutationResult<LoginMutationMutation>;
export type LoginMutationMutationOptions = Apollo.BaseMutationOptions<LoginMutationMutation, LoginMutationMutationVariables>;
export const RefreshMutationDocument = gql`
    mutation RefreshMutation($input: RefreshInput!) {
  refreshToken(input: $input) {
    ... on LoginToken {
      accessToken
      refreshToken
      expiresIn
    }
    ... on LoginError {
      error
      errorDescription
    }
  }
}
    `;
export type RefreshMutationMutationFn = Apollo.MutationFunction<RefreshMutationMutation, RefreshMutationMutationVariables>;

/**
 * __useRefreshMutationMutation__
 *
 * To run a mutation, you first call `useRefreshMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshMutationMutation, { data, loading, error }] = useRefreshMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshMutationMutation(baseOptions?: Apollo.MutationHookOptions<RefreshMutationMutation, RefreshMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshMutationMutation, RefreshMutationMutationVariables>(RefreshMutationDocument, options);
      }
export type RefreshMutationMutationHookResult = ReturnType<typeof useRefreshMutationMutation>;
export type RefreshMutationMutationResult = Apollo.MutationResult<RefreshMutationMutation>;
export type RefreshMutationMutationOptions = Apollo.BaseMutationOptions<RefreshMutationMutation, RefreshMutationMutationVariables>;
export const RegisterMutationDocument = gql`
    mutation RegisterMutation($input: NewUserInput!) {
  createUser(input: $input) {
    id
    name
  }
}
    `;
export type RegisterMutationMutationFn = Apollo.MutationFunction<RegisterMutationMutation, RegisterMutationMutationVariables>;

/**
 * __useRegisterMutationMutation__
 *
 * To run a mutation, you first call `useRegisterMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutationMutation, { data, loading, error }] = useRegisterMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutationMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutationMutation, RegisterMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutationMutation, RegisterMutationMutationVariables>(RegisterMutationDocument, options);
      }
export type RegisterMutationMutationHookResult = ReturnType<typeof useRegisterMutationMutation>;
export type RegisterMutationMutationResult = Apollo.MutationResult<RegisterMutationMutation>;
export type RegisterMutationMutationOptions = Apollo.BaseMutationOptions<RegisterMutationMutation, RegisterMutationMutationVariables>;
export const viewerDocument = gql`
    query viewer {
  viewer {
    ...ProfileData
  }
}
    ${ProfileDataFragmentDoc}`;

/**
 * __useviewerQuery__
 *
 * To run a query within a React component, call `useviewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useviewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useviewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useviewerQuery(baseOptions?: Apollo.QueryHookOptions<viewerQuery, viewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<viewerQuery, viewerQueryVariables>(viewerDocument, options);
      }
export function useviewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<viewerQuery, viewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<viewerQuery, viewerQueryVariables>(viewerDocument, options);
        }
export type viewerQueryHookResult = ReturnType<typeof useviewerQuery>;
export type viewerLazyQueryHookResult = ReturnType<typeof useviewerLazyQuery>;
export type viewerQueryResult = Apollo.QueryResult<viewerQuery, viewerQueryVariables>;
export function refetchviewerQuery(variables?: viewerQueryVariables) {
      return { query: viewerDocument, variables: variables }
    }
export const mutateViewerDocument = gql`
    mutation mutateViewer($input: ViewerEditInput!) {
  mutateViewer(input: $input) {
    ...ProfileData
  }
}
    ${ProfileDataFragmentDoc}`;
export type mutateViewerMutationFn = Apollo.MutationFunction<mutateViewerMutation, mutateViewerMutationVariables>;

/**
 * __usemutateViewerMutation__
 *
 * To run a mutation, you first call `usemutateViewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usemutateViewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateViewerMutation, { data, loading, error }] = usemutateViewerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usemutateViewerMutation(baseOptions?: Apollo.MutationHookOptions<mutateViewerMutation, mutateViewerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<mutateViewerMutation, mutateViewerMutationVariables>(mutateViewerDocument, options);
      }
export type mutateViewerMutationHookResult = ReturnType<typeof usemutateViewerMutation>;
export type mutateViewerMutationResult = Apollo.MutationResult<mutateViewerMutation>;
export type mutateViewerMutationOptions = Apollo.BaseMutationOptions<mutateViewerMutation, mutateViewerMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ApiNode": [
      "AclRole",
      "Calendar",
      "CalendarEvent",
      "City",
      "CustomDomainNameDnsRecords",
      "CustomDomainNameRequest",
      "EventAttendee",
      "EventCategory",
      "EventImport",
      "EventNotificationTemplate",
      "EventTag",
      "EventType",
      "EventTypeNotificationTemplate",
      "EventTypeTag",
      "Media",
      "MediaDocumentType",
      "NodeMedia",
      "NotificationData",
      "NotificationQueue",
      "NotificationTemplate",
      "NotificationTemplateLocale",
      "OrganizationBranch",
      "Organizer",
      "Pathway",
      "PathwayItem",
      "PathwayNotificationTemplate",
      "PathwayTag",
      "Profile",
      "Recurrence",
      "Setting",
      "UserActionLog"
    ],
    "EventData": [
      "CalendarEvent",
      "EventType"
    ],
    "LoginResponse": [
      "LoginError",
      "LoginToken"
    ],
    "NodeIdentifier": [],
    "NodeTag": [
      "EventTag",
      "EventTypeTag",
      "PathwayTag"
    ],
    "NodeWithFiles": [],
    "OwnedApiNode": [
      "AclRole",
      "Calendar",
      "CalendarEvent",
      "CustomDomainNameDnsRecords",
      "CustomDomainNameRequest",
      "EventCategory",
      "EventImport",
      "EventNotificationTemplate",
      "EventType",
      "EventTypeNotificationTemplate",
      "Media",
      "MediaDocumentType",
      "NotificationTemplate",
      "Organizer",
      "Pathway",
      "PathwayNotificationTemplate",
      "Profile",
      "Setting",
      "UserActionLog"
    ],
    "RelatedNotificationTemplate": [
      "EventNotificationTemplate",
      "EventTypeNotificationTemplate",
      "PathwayNotificationTemplate"
    ]
  }
};
      export default result;
    